import React, { useState } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import './SuperMarket.css';

function ElectricalAppliances() {
  const [categories] = useState({

                    "Televisions/ T.Vs": [
                  { "name": "Samsung Crystal 4K 43-inch Smart TV", "price": 29490 },
  { "name": "Sony Bravia 55-inch 4K Google TV", "price": 54990 },
  { "name": "LG UR7500 55-inch 4K WebOS TV", "price": 41490 },
  { "name": "Panasonic TH32MS660DX 32-inch Smart TV", "price": 14990 },
  { "name": "Mi X Pro 55-inch 4K Google TV", "price": 37999 },
  { "name": "Motorola 43-inch QLED Google TV", "price": 21999 },
  { "name": "iFFALCON 43-inch 4K Google TV", "price": 18499 },
  { "name": "Thomson Alpha QLED 40-inch Smart TV", "price": 12999 },
  { "name": "Foxsky 32-inch HD Ready Google TV", "price": 7499 },
  { "name": "Hisense 55-inch 4K Google TV", "price": 30999 },
  { "name": "Redmi 32-inch Fire TV", "price": 9999 },
  { "name": "Vu 65-inch QLED 4K Smart TV", "price": 41499 },
  { "name": "TCL V5C 32-inch QLED Full HD TV", "price": 13490 },
  { "name": "Philips 32-inch HD Ready Google TV", "price": 9999 },
  { "name": "Skywall 43-inch Full HD Smart TV", "price": 12999 },
  { "name": "Kodak 32-inch HD Ready Smart TV", "price": 7999 },
  { "name": "VW 32-inch Frameless HD Smart TV", "price": 7199 },
  { "name": "Realme TechLife 32-inch QLED Google TV", "price": 9499 },
  { "name": "Xiaomi A Series 32-inch Google TV", "price": 11999 },
  { "name": "Samsung Vision AI 55-inch QLED TV", "price": 49990 },
  { "name": "Sony Bravia 43-inch 4K Google TV", "price": 38490 },
  { "name": "LG AI TV 43-inch 4K WebOS", "price": 29990 },
  { "name": "Foxsky 50-inch QLED 4K Google TV", "price": 24999 },
  { "name": "Thomson Alpha QLED 32-inch Smart TV", "price": 8499 },
  { "name": "Panasonic 32-inch HD Ready Google TV", "price": 14990 },
  { "name": "Mi A Pro 43-inch 4K Google TV", "price": 23999 },
  { "name": "Samsung Crystal Vision 43-inch 4K TV", "price": 30490 },
  { "name": "iFFALCON 32-inch HD Ready Google TV", "price": 8999 },
  { "name": "Motorola 55-inch QLED Google TV", "price": 31999 },
  { "name": "Sony Bravia 55-inch 4K Google TV (2025)", "price": 65990 },
  { "name": "LG UR7500 43-inch 4K WebOS TV", "price": 29990 },
  { "name": "Samsung Crystal 4K 55-inch Smart TV", "price": 41490 },
  { "name": "Hisense 65-inch 4K Google TV", "price": 41990 },
  { "name": "Redmi 43-inch F Series Fire TV", "price": 13999 },
  { "name": "Vu 43-inch 4K Android TV", "price": 23999 },
  { "name": "TCL 32-inch HD Ready Google TV", "price": 13490 },
  { "name": "Philips 43-inch Full HD Google TV", "price": 17990 },
  { "name": "Skywall 32-inch HD Ready Smart TV", "price": 7399 },
  { "name": "Kodak 40-inch Full HD Smart TV", "price": 12999 },
  { "name": "VW 43-inch Full HD Smart TV", "price": 13799 },
  { "name": "Realme 32-inch HD Ready Smart TV", "price": 8499 },
  { "name": "Xiaomi 50-inch X Series 4K TV", "price": 32990 },
  { "name": "Samsung Crystal 4K 65-inch Smart TV", "price": 64990 },
  { "name": "Sony Bravia 43-inch 4K LED TV", "price": 41990 },
  { "name": "LG 32-inch HD Ready Smart TV", "price": 13590 },
  { "name": "Foxsky 24-inch HD Ready Smart TV", "price": 5499 },
  { "name": "Thomson 32-inch HD Ready Smart TV", "price": 7999 },
  { "name": "Panasonic 43-inch Full HD Smart TV", "price": 22990 },
  { "name": "Mi 32-inch HD Ready Smart TV", "price": 13490 },



  { "name": "OnePlus Y1S Pro 55-inch 4K Android TV", "price": 39999 },
  { "name": "Haier S800QT 65-inch QLED Google TV", "price": 49990 },
  { "name": "Acer M Series 65-inch QLED Mini LED TV", "price": 89999 },
  { "name": "Croma 43-inch 4K Ultra HD LED Tizen TV", "price": 25490 },
  { "name": "Daiwa 43G1U 4K LED Smart Google TV", "price": 21499 },
  { "name": "Daiwa 55G1U 4K LED Smart Google TV", "price": 33999 },
  { "name": "Daiwa 32G1H HD Ready Smart Google TV", "price": 10999 },
  { "name": "Daiwa 32G1Q QLED HD Ready Smart TV", "price": 11499 },
  { "name": "Daiwa 43G1Q QLED 4K Smart Google TV", "price": 21999 },
  { "name": "Daiwa 55G1Q QLED 4K Smart Google TV", "price": 34990 },
  { "name": "Xiaomi Smart TV X Pro 43-inch QLED", "price": 34999 },
  { "name": "Xiaomi Smart TV X Pro 55-inch QLED", "price": 49999 },
  { "name": "Xiaomi Smart TV X Pro 65-inch QLED", "price": 62999 },
  { "name": "Xiaomi Smart TV X Series 50-inch", "price": 35999 },
  { "name": "Xiaomi Smart TV X Series 55-inch", "price": 39999 },
  { "name": "Xiaomi Smart TV X Series 65-inch", "price": 46999 },
  { "name": "Philips Lumina 43-inch QLED Google TV", "price": 24999 },
  { "name": "Philips Lumina 50-inch QLED Google TV", "price": 28999 },
  { "name": "Philips Lumina 55-inch QLED Google TV", "price": 32999 },
  { "name": "Philips Mirage 32-inch Full HD Smart TV", "price": 9999 },
  { "name": "TCL Q6C 55-inch Mini LED Google TV", "price": 49990 },
  { "name": "TCL C7K 55-inch Mini LED Google TV", "price": 79990 },
  { "name": "TCL T89C 55-inch QLED Google TV", "price": 44990 },
  { "name": "TCL QM6K 50-inch Mini LED Google TV", "price": 64999 },
  { "name": "LG UA8200 50-inch 4K Smart LED TV", "price": 37990 },
  { "name": "LG UA8200 55-inch 4K Smart LED TV", "price": 43990 },
  { "name": "LG Magnit 118-inch Micro LED TV", "price": 19700000 },
  { "name": "Samsung Neo QLED 8K 65-inch TV", "price": 189990 },
  { "name": "Samsung MNA110MS1ACCXXL 110-inch Micro LED TV", "price": 11500000 },
  { "name": "Samsung QEF1 55-inch QLED Smart TV", "price": 49990 },
  { "name": "Samsung Crystal 4K Neo 43-inch TV", "price": 28990 },
  { "name": "Samsung Crystal 4K Neo 55-inch TV", "price": 41990 },
  { "name": "Sony Bravia XR OLED 65-inch TV", "price": 179990 },
  { "name": "Sony Bravia XR OLED 55-inch TV", "price": 139990 },
  { "name": "Sony Bravia XR OLED 43-inch TV", "price": 99990 },
  { "name": "Sony Bravia XR Mini LED 85-inch TV", "price": 600000 },
  { "name": "Sony Bravia XR Mini LED 75-inch TV", "price": 429990 },
  { "name": "Sony Bravia XR Mini LED 65-inch TV", "price": 299990 },
  { "name": "Sony Bravia XR Mini LED 55-inch TV", "price": 199990 },
  { "name": "Sony Bravia XR Mini LED 43-inch TV", "price": 149990 },
  { "name": "Vu Vibe 43-inch QLED Smart TV", "price": 30999 },
  { "name": "Vu Vibe 50-inch QLED Smart TV", "price": 35999 },
  { "name": "Vu Vibe 55-inch QLED Smart TV", "price": 41999 },
  { "name": "Vu Vibe 65-inch QLED Smart TV", "price": 58999 },
  { "name": "Vu Masterpiece 85-inch QLED TV", "price": 169990 },
  { "name": "Vu Masterpiece 98-inch QLED TV", "price": 76990 },
  { "name": "Acer G Series 32-inch HD Smart TV", "price": 13499 },
  { "name": "Acer G Series 55-inch 4K Smart TV", "price": 37999 },
  { "name": "MeerVision Era Plus 55-inch 4K Smart TV", "price": 30200 },
  { "name": "MeerVision Era Plus 43-inch Full HD Smart TV", "price": 16900 },




  { "name": "Infinix 32Y1 HD Ready Smart TV", "price": 9499 },
  { "name": "Infinix 43X3 4K Smart TV", "price": 22999 },
  { "name": "Infinix 50X3 4K Smart TV", "price": 27999 },
  { "name": "Infinix 65X3 4K Smart TV", "price": 39999 },
  { "name": "Akai 32-inch HD Ready Smart TV", "price": 9999 },
  { "name": "Akai 43-inch Full HD Smart TV", "price": 14999 },
  { "name": "Akai 55-inch 4K Smart TV", "price": 39990 },
  { "name": "Cornea 85CORFLS05 85-inch 4K Smart TV", "price": 184055 },
  { "name": "Cornea 65-inch Frameless 4K Smart TV", "price": 49999 },
  { "name": "Cornea 43-inch Full HD Smart TV", "price": 18999 },
  { "name": "Croma 32-inch HD Ready Smart TV", "price": 12999 },
  { "name": "Croma 50-inch 4K Ultra HD Smart TV", "price": 29990 },
  { "name": "Croma 65-inch 4K Ultra HD Smart TV", "price": 44990 },
  { "name": "Nokia 43-inch Full HD Android TV", "price": 23999 },
  { "name": "Nokia 55-inch 4K QLED Android TV", "price": 44999 },
  { "name": "Nokia 65-inch 4K QLED Android TV", "price": 59999 },
  { "name": "BPL 32-inch HD Ready Smart TV", "price": 8999 },
  { "name": "BPL 43-inch Full HD Smart TV", "price": 14999 },
  { "name": "BPL 55-inch 4K Smart TV", "price": 29999 },
  { "name": "Sansui 32-inch HD Ready Smart TV", "price": 9499 },
  { "name": "Sansui 43-inch Full HD Smart TV", "price": 15999 },
  { "name": "Sansui 55-inch 4K Smart TV", "price": 31999 },
  { "name": "Noble Skiodo 32-inch HD Ready Smart TV", "price": 7999 },
  { "name": "Noble Skiodo 43-inch Full HD Smart TV", "price": 13999 },
  { "name": "Noble Skiodo 50-inch 4K Smart TV", "price": 26999 },
  { "name": "Detel 32-inch HD Ready Smart TV", "price": 6999 },
  { "name": "Detel 43-inch Full HD Smart TV", "price": 11999 },
  { "name": "Detel 55-inch 4K Smart TV", "price": 24999 },
  { "name": "Intex 32-inch HD Ready Smart TV", "price": 7999 },
  { "name": "Intex 43-inch Full HD Smart TV", "price": 13999 },
  { "name": "Intex 55-inch 4K Smart TV", "price": 28999 },
  { "name": "Sanyo 32-inch HD Ready Smart TV", "price": 8999 },
  { "name": "Sanyo 43-inch Full HD Smart TV", "price": 14999 },
  { "name": "Sanyo 55-inch 4K Smart TV", "price": 29999 },
  { "name": "Toshiba 32-inch HD Ready Smart TV", "price": 9999 },
  { "name": "Toshiba 43-inch Full HD Smart TV", "price": 16999 },
  { "name": "Toshiba 55-inch 4K Smart TV", "price": 34999 },
  { "name": "Sharp 32-inch HD Ready Smart TV", "price": 9499 },
  { "name": "Sharp 43-inch Full HD Smart TV", "price": 15999 },
  { "name": "Sharp 55-inch 4K Smart TV", "price": 32999 },
  { "name": "Hitachi 32-inch HD Ready Smart TV", "price": 9999 },
  { "name": "Hitachi 43-inch Full HD Smart TV", "price": 16999 },
  { "name": "Hitachi 55-inch 4K Smart TV", "price": 34999 },
  { "name": "Westinghouse 32-inch HD Ready Smart TV", "price": 7999 },
  { "name": "Westinghouse 43-inch Full HD Smart TV", "price": 13999 },
  { "name": "Westinghouse 55-inch 4K Smart TV", "price": 28999 },
  { "name": "Cooaa 32-inch HD Ready Smart TV", "price": 8499 },
  { "name": "Cooaa 43-inch Full HD Smart TV", "price": 14999 },
  { "name": "Cooaa 55-inch 4K Smart TV", "price": 31999 },




  { "name": "Onida 50UIG-R 50-inch 4K Smart LED TV", "price": 28990 },
  { "name": "Blaupunkt 50CSA7007 50-inch 4K Smart LED TV", "price": 21999 },
  { "name": "Thomson 50OPMAXGT9020 50-inch 4K Smart LED TV", "price": 23999 },
  { "name": "Acer AR50QDXGU2875AT 50-inch QLED Smart TV", "price": 33999 },
  { "name": "iFFALCON iFF50U64 50-inch 4K Smart LED TV", "price": 19999 },
  { "name": "Samsung UA50UE81AFUXXL 50-inch 4K Smart LED TV", "price": 40990 },
  { "name": "Sony BRAVIA K-50S20B 50-inch 4K Smart LED TV", "price": 56990 },
  { "name": "LG 50UR75006LC 50-inch 4K Smart LED TV", "price": 37990 },
  { "name": "TCL 50V6B 50-inch 4K Smart LED TV", "price": 28490 },
  { "name": "Motorola EnvisionX 50UHDGDMBSXP 50-inch 4K TV", "price": 26999 },
  { "name": "Xiaomi X Series L50MA-AUIN 50-inch 4K Smart TV", "price": 29990 },
  { "name": "Toshiba 50C350NP 50-inch 4K Smart LED TV", "price": 29990 },
  { "name": "Daiwa D50U2WOS 50-inch 4K Smart LED TV", "price": 27999 },
  { "name": "TCL 50V6C 50-inch 4K Smart LED TV", "price": 33990 },
  { "name": "Hisense 50A6K 50-inch 4K Smart LED TV", "price": 35990 },
  { "name": "Acerpure AP50UG51ASFTD 50-inch 4K Smart TV", "price": 29990 },
  { "name": "TCL 50P635 Pro 50-inch 4K Smart LED TV", "price": 22999 },
  { "name": "Sony BRAVIA K-50S22BM2 50-inch 4K Smart LED TV", "price": 59990 },
  { "name": "Samsung UA50DUE76AK 50-inch 4K Smart LED TV", "price": 39990 },
  { "name": "LG 50UR7500PSC 50-inch 4K Smart LED TV", "price": 35490 },
  { "name": "Vu GloLED 50GLOLED25 50-inch 4K Smart LED TV", "price": 28999 },
  { "name": "Realme TechLife CineSonic Q 50-inch QLED TV", "price": 28999 },
  { "name": "Samsung Q60D QA50Q60DAULXL 50-inch QLED TV", "price": 49899 },
  { "name": "Acer V Series AR50GR2851VQD 50-inch QLED TV", "price": 28999 },
  { "name": "Xiaomi Redmi TV A50 50-inch 4K Smart LED TV", "price": 17999 },
  { "name": "Sony BRAVIA K-50S22M2 50-inch 4K Smart LED TV", "price": 63340 },
  { "name": "Blaupunkt 50QC7015 50-inch QLED Smart TV", "price": 27999 },
  { "name": "Earthonic AE50UH4KQ719F 50-inch QLED Smart TV", "price": 26999 },
  { "name": "Toshiba 50E350RP 50-inch 4K Smart LED TV", "price": 28999 },
  { "name": "Hisense 50E7Q 50-inch QLED Smart TV", "price": 31999 },
  { "name": "Sony BRAVIA K-50S22BM2 50-inch 4K Smart LED TV", "price": 58990 },
  { "name": "iFFALCON 50U65 50-inch 4K Smart LED TV", "price": 29999 },
  { "name": "Samsung UA50UE84AFUXXL 50-inch 4K Smart LED TV", "price": 40990 },
  { "name": "Acer Super Series AR50QDXGU2875AT 50-inch QLED TV", "price": 33999 },
  { "name": "Sony BRAVIA K-50S25M2 50-inch 4K Smart LED TV", "price": 59990 },
  { "name": "Vu Vibe Series 50VIBE-DV 50-inch QLED Smart TV", "price": 31490 },
  { "name": "VW VW50GQ1 50-inch QLED Smart TV", "price": 23999 },
  { "name": "Blaupunkt Cybersound 50CSA7007 50-inch LED TV", "price": 21999 },
  { "name": "Samsung UA50AUE60AK 50-inch 4K Smart LED TV", "price": 40490 },
  { "name": "Sony BRAVIA K-50S20B 50-inch 4K Smart LED TV", "price": 56990 },
  { "name": "LG 50UR75006LA 50-inch 4K Smart LED TV", "price": 37990 },
  { "name": "Acer I PRO Series AR50UDIGU2875AT 50-inch LED TV", "price": 27990 },
  { "name": "TCL 50V6B 50-inch 4K Smart LED TV", "price": 28490 },
  { "name": "Motorola 50UHDGDMBSXP 50-inch 4K Smart LED TV", "price": 26999 },
  { "name": "Xiaomi L50MA-AUIN 50-inch X Series 4K TV", "price": 29990 },
  { "name": "Toshiba 50C350NP 50-inch 4K Smart LED TV", "price": 29990 },
  { "name": "Daiwa D50U2WOS 50-inch 4K Smart LED TV", "price": 27999 },
  { "name": "TCL 50V6C 50-inch 4K Smart LED TV", "price": 33990 },
  { "name": "Hisense 50A6K 50-inch 4K Smart LED TV", "price": 35990 },



  { "name": "Samsung The Wall 146-inch MicroLED Modular TV", "price": 12000000 },
  { "name": "LG Magnit 163-inch MicroLED Display", "price": 14500000 },
  { "name": "Sony Crystal LED 220-inch Display System", "price": 18000000 },
  { "name": "Samsung 98-inch QN990C Neo QLED 8K TV", "price": 899990 },
  { "name": "LG 97-inch G2 OLED evo Gallery Edition", "price": 799990 },
  { "name": "Sony BRAVIA XR Z9K 85-inch 8K Mini LED TV", "price": 699990 },
  { "name": "TCL 98-inch X955 QD-Mini LED 4K TV", "price": 599990 },
  { "name": "Hisense 100-inch UX 4K ULED X TV", "price": 499990 },
  { "name": "Vu Masterpiece Glo 100-inch QLED TV", "price": 429990 },
  { "name": "Panasonic 98-inch TH-98SQ1W 4K Professional Display", "price": 399990 },
  { "name": "Samsung 85-inch QN900D Neo QLED 8K TV", "price": 549990 },
  { "name": "LG 88-inch Z2 OLED 8K TV", "price": 599990 },
  { "name": "Sony BRAVIA XR A95L 77-inch QD-OLED TV", "price": 479990 },
  { "name": "TCL 85-inch C845 QD-Mini LED TV", "price": 349990 },
  { "name": "Hisense 85-inch U8K Mini LED TV", "price": 329990 },
  { "name": "Vu 85-inch GloLED 4K Smart TV", "price": 299990 },
  { "name": "Samsung 85-inch Frame QLED Art TV", "price": 319990 },
  { "name": "LG 86-inch QNED91 4K Smart TV", "price": 289990 },
  { "name": "Sony BRAVIA XR X95L 85-inch Mini LED TV", "price": 379990 },
  { "name": "TCL 85-inch QM8 Mini LED TV", "price": 309990 },
  { "name": "Philips 86-inch 8607 QLED Ambilight TV", "price": 289990 },
  { "name": "Panasonic 86-inch TH-86EQ1W 4K Display", "price": 269990 },
  { "name": "Samsung 85-inch Q80D QLED TV", "price": 259990 },
  { "name": "LG 86-inch UR80 4K UHD Smart TV", "price": 239990 },
  { "name": "Sony BRAVIA XR X90L 85-inch Full Array LED TV", "price": 249990 },
  { "name": "TCL 85-inch P745 4K Smart TV", "price": 219990 },
  { "name": "Hisense 85-inch A7H 4K UHD TV", "price": 199990 },
  { "name": "Vu 85-inch Cinema TV Action Series", "price": 189990 },
  { "name": "Samsung 85-inch BU8000 Crystal UHD TV", "price": 179990 },
  { "name": "LG 86-inch Nano90 NanoCell TV", "price": 169990 },
  { "name": "Sony BRAVIA XR A80L 77-inch OLED TV", "price": 189990 },
  { "name": "TCL 85-inch C645 QLED TV", "price": 159990 },
  { "name": "Hisense 85-inch Tornado 2.0 TV with JBL Speakers", "price": 149990 },
  { "name": "Vu 100-inch Cinema TV 4K", "price": 399990 },
  { "name": "Samsung 98-inch Q80Z QLED TV", "price": 699990 },
  { "name": "LG 98-inch QNED99 8K Smart TV", "price": 749990 },
  { "name": "Sony BRAVIA XR Z9J 85-inch 8K LED TV", "price": 649990 },
  { "name": "TCL 98-inch X11G Mini LED TV", "price": 799990 },
  { "name": "Hisense 100-inch L9G Laser TV", "price": 599990 },
  { "name": "Vu 98-inch Masterpiece QLED TV", "price": 499990 },
  { "name": "Samsung 110-inch The Wall All-in-One", "price": 999990 },
  { "name": "LG 136-inch Magnit MicroLED Display", "price": 1299990 },
  { "name": "Sony 219-inch CLEDIS Display System", "price": 1599990 },
  { "name": "Panasonic 98-inch TH-98LQ70W 4K Display", "price": 449990 },
  { "name": "Philips 86-inch OLED986 Ambilight TV", "price": 399990 },
  { "name": "TCL 115-inch X11H QD-Mini LED TV", "price": 899990 },
  { "name": "Samsung 85-inch S95D OLED TV", "price": 349990 },
  { "name": "LG 83-inch C3 OLED evo TV", "price": 329990 },
  { "name": "Sony BRAVIA XR A90J 83-inch OLED TV", "price": 359990 },

                  

                  ],
                
                  "Air Conditioners/ACS": [
                  
                    
  { "name": "Blue Star 2 Ton 5 Star Inverter Split AC", "price": 84000 },
  { "name": "Lloyd 1.5 Ton 3 Star Inverter Split AC", "price": 60990 },
  { "name": "FYHALE 8000 BTU Wall Mounted AC with Heat Function", "price": 9020 },
  { "name": "DELLA Vario Series 12000 BTU Mini Split AC", "price": 109909 },
  { "name": "Voltas 1.5 Ton 3 Star Inverter Split AC", "price": 45000 },
  { "name": "LG 1.5 Ton 5 Star Dual Inverter Split AC", "price": 60000 },
  { "name": "Haier 1.5 Ton 5 Star Triple Inverter Split AC", "price": 58000 },
  { "name": "Daikin 1.5 Ton 3 Star Inverter Split AC", "price": 52000 },
  { "name": "Hitachi 1.5 Ton 5 Star Inverter Split AC", "price": 63000 },
  { "name": "Samsung Wind-Free 1.5 Ton Inverter Split AC", "price": 57000 },
  { "name": "Panasonic 1.5 Ton 5 Star Wi-Fi Inverter Split AC", "price": 55000 },
  { "name": "Godrej 1.5 Ton 3 Star Inverter Split AC", "price": 42000 },
  { "name": "Whirlpool Magicool 1.5 Ton 5 Star Inverter Split AC", "price": 48000 },
  { "name": "Carrier 1.8 Ton 5 Star Inverter Split AC", "price": 58000 },
  { "name": "O General 1.5 Ton 3 Star Inverter Split AC", "price": 90000 },
  { "name": "Cruise 1.5 Ton 3 Star Inverter Split AC", "price": 47000 },
  { "name": "IFB 1.5 Ton 4 Star Inverter Split AC", "price": 49000 },
  { "name": "Midea 1.5 Ton 3 Star Inverter Split AC", "price": 44000 },
  { "name": "Onida 1.5 Ton 3 Star Split AC", "price": 41000 },
  { "name": "Realme TechLife 1.5 Ton 3 Star Inverter Split AC", "price": 43000 },


  
  { "name": "Carrier 2 Ton 5 Star Wi-Fi Smart Inverter Split AC", "price": 54990 },
  { "name": "Cruise 1 Ton 3 Star Inverter Split AC", "price": 25590 },
  { "name": "Panasonic 2 Ton 4 Star Wi-Fi Inverter Split AC", "price": 53990 },
  { "name": "Samsung 1.5 Ton 3 Star AI Inverter Smart Split AC", "price": 35489 },
  { "name": "LG 1 Ton 4 Star DUAL Inverter Split AC", "price": 34490 },
  { "name": "Voltas 1.4 Ton 3 Star Inverter Split AC", "price": 32490 },
  { "name": "Daikin 1.5 Ton 3 Star Inverter Split AC", "price": 36990 },
  { "name": "Blue Star 1.5 Ton 5 Star Wi-Fi Smart Inverter Split AC", "price": 43490 },
  { "name": "Godrej 1.5 Ton 3 Star Inverter Split AC", "price": 31490 },
  { "name": "Whirlpool 1.5 Ton 3 Star Magicool Inverter Split AC", "price": 31490 },
  { "name": "Hitachi 1.5 Ton Class 5 Star Inverter Split AC", "price": 43990 },
  { "name": "OGeneral 1.5 Ton 3 Star Split AC", "price": 59999 },
  { "name": "TCL Elite Turbo 2 Ton 3 Star Ultra-Inverter Split AC", "price": 39990 },
  { "name": "Mitsubishi Heavy Duty 1.5 Ton 5 Star Split AC", "price": 65990 },
  { "name": "Sharp 1.5 Ton 3 Star Inverter Split AC", "price": 38990 },
  { "name": "Electrolux 1.5 Ton 3 Star Split AC", "price": 34990 },
  { "name": "Kelvinator 1.5 Ton 3 Star Inverter Split AC", "price": 31990 },
  { "name": "BPL 1.5 Ton 3 Star Split AC", "price": 29990 },
  { "name": "Sansui 1.5 Ton 3 Star Inverter Split AC", "price": 30990 },
  { "name": "Toshiba 1.5 Ton 5 Star Inverter Split AC", "price": 44990 },
  { "name": "AmazonBasics 1.5 Ton 3 Star Split AC", "price": 28990 },
  { "name": "Intex 1.5 Ton 3 Star Split AC", "price": 27990 },
  { "name": "Micromax 1.5 Ton 3 Star Split AC", "price": 26990 },
  { "name": "Akai 1.5 Ton 3 Star Split AC", "price": 25990 },
  { "name": "Super General 1.5 Ton 3 Star Split AC", "price": 28990 },
  { "name": "Mitashi 1.5 Ton 3 Star Split AC", "price": 27990 },
  { "name": "Hyundai 1.5 Ton 3 Star Split AC", "price": 29990 },
  { "name": "Videocon 1.5 Ton 3 Star Split AC", "price": 28990 },
  { "name": "Onida 1 Ton 3 Star Split AC", "price": 25990 },
  { "name": "Realme TechLife 1 Ton 3 Star Inverter Split AC", "price": 27990 },
  { "name": "Hisense 1.5 Ton 3 Star Split AC", "price": 31990 },
  { "name": "Thomson 1.5 Ton 3 Star Split AC", "price": 30990 },
  { "name": "Croma 1.5 Ton 3 Star Split AC", "price": 31990 },
  { "name": "MarQ by Flipkart 1.5 Ton 3 Star Split AC", "price": 28990 },
  { "name": "iBell 1.5 Ton 3 Star Split AC", "price": 26990 },
  { "name": "Luminous 1.5 Ton 3 Star Split AC", "price": 29990 },
  { "name": "Syska 1.5 Ton 3 Star Split AC", "price": 28990 },
  { "name": "Reconnect 1.5 Ton 3 Star Split AC", "price": 27990 },
  { "name": "T-Series 1.5 Ton 3 Star Split AC", "price": 26990 },
  { "name": "Nokia 1.5 Ton 3 Star Split AC", "price": 31990 },
  { "name": "Vu 1.5 Ton 3 Star Split AC", "price": 30990 },
  { "name": "Detel 1.5 Ton 3 Star Split AC", "price": 25990 },
  { "name": "Zebronics 1.5 Ton 3 Star Split AC", "price": 27990 },
  { "name": "Inalsa 1.5 Ton 3 Star Split AC", "price": 28990 },
  { "name": "Orient Electric 1.5 Ton 3 Star Split AC", "price": 29990 },
  { "name": "Havells 1.5 Ton 3 Star Split AC", "price": 31990 },
  { "name": "Atomberg 1.5 Ton 3 Star Split AC", "price": 32990 },
  { "name": "Usha 1.5 Ton 3 Star Split AC", "price": 30990 },
  { "name": "Voltas Beko 1.5 Ton 3 Star Split AC", "price": 31990 },


  
  { "name": "Carrier 1.5 Ton 3 Star AI Flexicool Inverter Split AC", "price": 33990 },
  { "name": "Voltas 2 Ton 3 Star Inverter Split AC", "price": 52990 },
  { "name": "Samsung 2 Ton 3 Star WindFree Inverter Split AC", "price": 58990 },
  { "name": "LG 1.5 Ton 3 Star DUAL Inverter Window AC", "price": 33990 },
  { "name": "Daikin 1 Ton 3 Star Inverter Split AC", "price": 33489 },
  { "name": "Blue Star 1 Ton 5 Star Wi-Fi Smart Inverter Split AC", "price": 37790 },
  { "name": "Whirlpool 1 Ton 3 Star Magicool Inverter Split AC", "price": 31490 },
  { "name": "Godrej 1 Ton 3 Star Inverter Split AC", "price": 31490 },
  { "name": "Hitachi 1 Ton Class 3 Star Inverter Split AC", "price": 32490 },
  { "name": "Panasonic 1 Ton 3 Star Wi-Fi Inverter Split AC", "price": 31990 },
  { "name": "Lloyd 1 Ton 3 Star Inverter Split AC", "price": 32490 },
  { "name": "Haier 1 Ton 5 Star AI Climate Control Smart Split AC", "price": 35990 },
  { "name": "Cruise 1.5 Ton 5 Star Inverter Split AC", "price": 32990 },
  { "name": "TCL 1.5 Ton 3 Star Ultra-Inverter Split AC", "price": 35990 },
  { "name": "Mitsubishi Electric 1.5 Ton 5 Star Split AC", "price": 68990 },
  { "name": "Sharp 1 Ton 3 Star Inverter Split AC", "price": 31990 },
  { "name": "Electrolux 1 Ton 3 Star Split AC", "price": 30990 },
  { "name": "Kelvinator 1 Ton 3 Star Inverter Split AC", "price": 29990 },
  { "name": "BPL 1 Ton 3 Star Split AC", "price": 28990 },
  { "name": "Sansui 1 Ton 3 Star Inverter Split AC", "price": 29990 },
  { "name": "Toshiba 1 Ton 5 Star Inverter Split AC", "price": 41990 },
  { "name": "AmazonBasics 1 Ton 3 Star Split AC", "price": 27990 },
  { "name": "Intex 1 Ton 3 Star Split AC", "price": 26990 },
  { "name": "Micromax 1 Ton 3 Star Split AC", "price": 25990 },
  { "name": "Akai 1 Ton 3 Star Split AC", "price": 24990 },
  { "name": "Super General 1 Ton 3 Star Split AC", "price": 26990 },
  { "name": "Mitashi 1 Ton 3 Star Split AC", "price": 25990 },
  { "name": "Hyundai 1 Ton 3 Star Split AC", "price": 27990 },
  { "name": "Videocon 1 Ton 3 Star Split AC", "price": 26990 },
  { "name": "Hisense 1 Ton 3 Star Split AC", "price": 28990 },
  { "name": "Thomson 1 Ton 3 Star Split AC", "price": 27990 },
  { "name": "Croma 1 Ton 3 Star Split AC", "price": 28990 },
  { "name": "MarQ by Flipkart 1 Ton 3 Star Split AC", "price": 26990 },
  { "name": "iBell 1 Ton 3 Star Split AC", "price": 25990 },
  { "name": "Luminous 1 Ton 3 Star Split AC", "price": 27990 },
  { "name": "Syska 1 Ton 3 Star Split AC", "price": 26990 },
  { "name": "Reconnect 1 Ton 3 Star Split AC", "price": 25990 },
  { "name": "T-Series 1 Ton 3 Star Split AC", "price": 24990 },
  { "name": "Nokia 1 Ton 3 Star Split AC", "price": 28990 },
  { "name": "Vu 1 Ton 3 Star Split AC", "price": 27990 },
  { "name": "Detel 1 Ton 3 Star Split AC", "price": 24990 },
  { "name": "Zebronics 1 Ton 3 Star Split AC", "price": 25990 },
  { "name": "Inalsa 1 Ton 3 Star Split AC", "price": 26990 },
  { "name": "Orient Electric 1 Ton 3 Star Split AC", "price": 27990 },
  { "name": "Havells 1 Ton 3 Star Split AC", "price": 28990 },
  { "name": "Atomberg 1 Ton 3 Star Split AC", "price": 29990 },
  { "name": "Usha 1 Ton 3 Star Split AC", "price": 27990 },
  { "name": "Voltas Beko 1 Ton 3 Star Split AC", "price": 28990 },
  { "name": "Realme TechLife 2 Ton 3 Star Inverter Split AC", "price": 49990 },


  
  { "name": "MRCOOL Universal Central Heat Pump Split System 3 Ton", "price": 406601 },
  { "name": "GREE MULTI42CVIR400 Quad-Zone Central AC System", "price": 628013 },
  { "name": "Cooper&Hunter Tri-Zone 48000 BTU Ductless Central AC", "price": 541435 },
  { "name": "Global Industrial 2 Ton Portable Central AC", "price": 503164 },
  { "name": "Senville 3 Ton Dual Zone Central AC Heat Pump", "price": 340829 },
  { "name": "Air-Con 2 Ton Central Mini Split AC System", "price": 171244 },
  { "name": "Goodman 5 Ton Multi-Speed Central Air Handler", "price": 230921 },
  { "name": "Cooper&Hunter Dual Zone 36000 BTU Central AC", "price": 464795 },
  { "name": "GREE 24000 BTU Central Mini Split AC System", "price": 308220 },
  { "name": "Air-Con Tri-Zone 3 Zone Central AC System", "price": 317553 },
  { "name": "Voltas Venture Slimline Tower AC 2 Ton", "price": 81900 },
  { "name": "Blue Star 2 Ton 3 Star Inverter Cassette AC", "price": 87990 },
  { "name": "Voltas C2-N Venture I-Cassette AC 2 Ton", "price": 79950 },
  { "name": "Carrier 3 Ton Central Ducted AC System", "price": 289990 },
  { "name": "Daikin VRV Central AC System 4 Ton", "price": 399990 },
  { "name": "LG Multi V Central AC System 5 Ton", "price": 459990 },
  { "name": "Samsung DVM S Central AC System 3 Ton", "price": 429990 },
  { "name": "Hitachi Set Free Mini Central AC 2.5 Ton", "price": 389990 },
  { "name": "Toshiba SMMS Central AC System 4 Ton", "price": 449990 },
  { "name": "Mitsubishi City Multi Central AC 3 Ton", "price": 419990 },
  { "name": "Haier MRV Central AC System 2 Ton", "price": 379990 },
  { "name": "OGeneral VRF Central AC System 3 Ton", "price": 409990 },
  { "name": "Sharp Central Ducted AC 2.5 Ton", "price": 369990 },
  { "name": "Electrolux Central AC System 3 Ton", "price": 389990 },
  { "name": "Kelvinator Central Ducted AC 2 Ton", "price": 349990 },
  { "name": "BPL Central AC System 2.5 Ton", "price": 359990 },
  { "name": "Sansui Central AC 3 Ton", "price": 379990 },
  { "name": "TCL Central AC System 2 Ton", "price": 339990 },
  { "name": "AmazonBasics Central AC 2 Ton", "price": 329990 },
  { "name": "Intex Central AC System 2.5 Ton", "price": 349990 },
  { "name": "Micromax Central AC 3 Ton", "price": 359990 },
  { "name": "Akai Central AC System 2 Ton", "price": 319990 },
  { "name": "Super General Central AC 2.5 Ton", "price": 339990 },
  { "name": "Mitashi Central AC System 3 Ton", "price": 349990 },
  { "name": "Hyundai Central AC 2 Ton", "price": 329990 },
  { "name": "Videocon Central AC System 2.5 Ton", "price": 339990 },
  { "name": "Hisense Central AC 3 Ton", "price": 359990 },
  { "name": "Thomson Central AC System 2 Ton", "price": 319990 },
  { "name": "Croma Central AC 2.5 Ton", "price": 329990 },
  { "name": "MarQ by Flipkart Central AC 3 Ton", "price": 339990 },
  { "name": "iBell Central AC System 2 Ton", "price": 319990 },
  { "name": "Luminous Central AC 2.5 Ton", "price": 329990 },
  { "name": "Syska Central AC System 3 Ton", "price": 339990 },
  { "name": "Reconnect Central AC 2 Ton", "price": 319990 },
  { "name": "T-Series Central AC System 2.5 Ton", "price": 329990 },
  { "name": "Nokia Central AC 3 Ton", "price": 349990 },
  { "name": "Vu Central AC System 2 Ton", "price": 319990 },
  { "name": "Detel Central AC 2.5 Ton", "price": 329990 },
  { "name": "Zebronics Central AC System 3 Ton", "price": 339990 },
  { "name": "Inalsa Central AC 2 Ton", "price": 319990 },


                  ],


                   "Others": [
                    { "name": "Others", "price": 40 },
                    { "name": "Other Mobile", "price": 6660 },
                    { "name": "Other Tab", "price": 5660 },
                    { "name": "Other T.V", "price": 4650 },
                    { "name": "Other AC", "price": 24660 },
                    { "name": "Other Speaker", "price": 2860 },
                    { "name": "Other mikes", "price": 1260 },
                    { "name": "Other set", "price": 660 },
                    { "name": "Other item", "price": 7660 },
                  

                  ],
                    "Emerging Tech & AI integration": [
                    { "name": "Dish Soap", "price": 40 },
                    { "name": "Detergent", "price": 60 },
                  

                  ],
                    "Electrical Appliances": [
                   
  { "name": "Prestige PIC 20 Induction Cooktop", "price": 1499 },
  { "name": "Bajaj Majesty DX 7 Dry Iron", "price": 699 },
  { "name": "Morphy Richards 23MCG Microwave Oven", "price": 8999 },
  { "name": "Philips GC1905 Steam Iron", "price": 1399 },
  { "name": "Pigeon Electric Kettle 1.5L", "price": 499 },
  { "name": "Kent Egg Boiler 7 Egg Capacity", "price": 799 },
  { "name": "Prestige Roti Maker PRM 3.0", "price": 1799 },
  { "name": "Usha OTGW 3615R Oven Toaster Grill", "price": 2999 },
  { "name": "Inalsa Air Fryer 2.3L", "price": 2999 },
  { "name": "Philips HL7756 Mixer Grinder", "price": 2999 },
  { "name": "Borosil Chef Delite Electric Chopper", "price": 1988 },
  { "name": "AGARO Marvel 9L Oven Toaster Griller", "price": 1998 },
  { "name": "Pigeon Amaze Plus Electric Kettle", "price": 499 },
  { "name": "Prestige PKOSS Electric Kettle 1.5L", "price": 699 },
  { "name": "AmazonBasics Electric Egg Boiler", "price": 399 },
  { "name": "Philips HL1655 Hand Blender", "price": 1763 },
  { "name": "iBELL EO19LG Oven Toaster Griller", "price": 3492 },
  { "name": "Wonderchef OTG 21L with Rotisserie", "price": 4899 },
  { "name": "Pigeon Zoom Electric Chopper", "price": 599 },
  { "name": "KENT Electric Chopper 250W", "price": 1274 },

  
  { "name": "AO Smith HSE-SAS-015 Storage Water Heater 15L", "price": 6499 },
  { "name": "Havells Instanio Instant Geyser 3L", "price": 3649 },
  { "name": "V-Guard Victo Plus 15L Storage Geyser", "price": 5999 },
  { "name": "Crompton Arno Neo 25L Storage Water Heater", "price": 5699 },
  { "name": "Bajaj Splendora Instant Water Heater 3L", "price": 2699 },
  { "name": "Orient Electric Enamour Classic Pro 25L Geyser", "price": 6399 },
  { "name": "Longway Superb 10L Instant Water Heater", "price": 2949 },
  { "name": "ACTIVA Instant Water Geyser 3L", "price": 1999 },
  { "name": "Polycab Intenso 3L Instant Geyser", "price": 2579 },
  { "name": "Usha Aqua Genie 15L Storage Water Heater", "price": 5299 },
  { "name": "Kent Grand RO Water Purifier 8L", "price": 10499 },
  { "name": "Aquaguard Aura RO+UV+Copper Water Purifier", "price": 15999 },
  { "name": "Pureit Eco Water Saver RO+UV+MF 10L", "price": 11999 },
  { "name": "Livpure Zinger Copper RO+UV+UF Water Purifier", "price": 8399 },
  { "name": "HUL Pureit Copper+ Mineral RO 7 Stage", "price": 11999 },
  { "name": "Urban Company Native M1 RO+UV+Copper+Alkaline", "price": 14499 },
  { "name": "Aquaguard Delight NXT RO+UV Water Purifier", "price": 8499 },
  { "name": "Kinsco Aqua Punch 15L Copper RO+UV+UF", "price": 4499 },
  { "name": "Proven Pixer Copper RO+UV+UF+TDS", "price": 3899 },
  { "name": "Havells Fab Alkaline RO+UV Water Purifier", "price": 8499 },
  { "name": "Eureka Forbes Aquaguard Vista UV+", "price": 7999 },
  { "name": "Sure Aquaguard Crown UV Water Purifier", "price": 5499 },
  { "name": "KENT Marvel RO+UF+UV LED Water Purifier", "price": 9199 },
  { "name": "AquaDart 25 LPH Commercial RO+UV Plant", "price": 7254 },
  { "name": "AquaDart 100 LPH Commercial RO+UV Plant", "price": 16000 },
  { "name": "AquaDpure 25 LPH Commercial RO+UV Plant", "price": 7254 },
  { "name": "Hydroshell 25 LPH Commercial RO Plant", "price": 7450 },
  { "name": "Aquaguard Classic AG 200 UV Water Purifier", "price": 12975 },
  { "name": "Native M2 RO+UV+Copper+Alkaline Water Purifier", "price": 18499 },
  { "name": "Aquaguard Aura 2X Life RO+UV+Copper", "price": 15999 },
  { "name": "AQUA D PURE 4-in-1 Copper RO Water Purifier", "price": 4749 },
  { "name": "Kinsco Aqua Punch Pro Max 21L RO+UV+UF", "price": 4002 },
  { "name": "Aquaguard Benefits RO+UV+MTDS Water Purifier", "price": 8499 },
  { "name": "Urban Company Native M2 Smart IoT Water Purifier", "price": 18499 },
  { "name": "Kent Ace Copper RO+UV+UF+TDS Water Purifier", "price": 11999 },
  { "name": "Havells Gracia Alkaline RO+UV Water Purifier", "price": 16599 },
  { "name": "AquaDart 50 LPH Commercial RO Plant", "price": 9951 },
  { "name": "AquaDart 100 LPH RO Plant with Auto Shut Off", "price": 16064 },
  { "name": "AquaDart 25 LPH UV Protection RO Plant", "price": 7358 },
  { "name": "Eureka Forbes Aqua Flo DX UV Water Purifier", "price": 5499 },
  { "name": "Kent Ace Mineral RO+UV+UF+TDS Water Purifier", "price": 11499 },
  { "name": "AO Smith Z9 Green RO Water Purifier", "price": 20999 },
  { "name": "Blue Star Eleanor RO+UV+UF+Alkaline", "price": 13999 },
  { "name": "LG WW174NP RO+UV+UF+Mineral Booster", "price": 18999 },
  { "name": "Moonbow Achelous Premium RO+UV+UF", "price": 9999 },
  { "name": "Hindware Elara RO+UV+UF+Minerals", "price": 8999 },
  { "name": "Aquaguard Mist NXT UV Water Purifier", "price": 6397 },
  { "name": "Aquaguard CLASSIC AG 200 UV Water Purifier", "price": 12975 },
  { "name": "Aqua Fresh Smoke Audi RO+UV+UF 18L", "price": 3540 },


  { "name": "Prestige PIC 16.0 Plus Induction Cooktop", "price": 1899 },
  { "name": "Philips HD4929 Induction Cooktop", "price": 2199 },
  { "name": "Bajaj Majesty ICX 7 Induction Cooker", "price": 2499 },
  { "name": "Usha Cook Joy Induction Cooktop", "price": 1799 },
  { "name": "Havells Insta Cook PT Induction", "price": 1999 },
  { "name": "Butterfly Rapid Kettle 1.5L", "price": 799 },
  { "name": "Prestige PKGSS 1.7L Electric Kettle", "price": 999 },
  { "name": "Morphy Richards InstaCook Kettle", "price": 1499 },
  { "name": "Kent Vogue Electric Kettle", "price": 1299 },
  { "name": "Inalsa Electric Kettle 1.5L", "price": 899 },
  { "name": "Philips HL7707 Mixer Grinder", "price": 4999 },
  { "name": "Bajaj Rex Mixer Grinder 500W", "price": 1999 },
  { "name": "Prestige Iris Mixer Grinder 750W", "price": 2999 },
  { "name": "Butterfly Jet Elite Mixer Grinder", "price": 2299 },
  { "name": "Usha Colt Mixer Grinder 500W", "price": 1899 },
  { "name": "Kent Hand Blender 400W", "price": 999 },
  { "name": "Philips HR1350 Hand Blender", "price": 1299 },
  { "name": "Inalsa Robot INOX 1000 Hand Blender", "price": 1799 },
  { "name": "Prestige Hand Blender PHB 6.0", "price": 1499 },
  { "name": "Bajaj HM01 Hand Mixer", "price": 1399 },
  { "name": "Morphy Richards Icon DLX Food Processor", "price": 6999 },
  { "name": "Inalsa INOX 1000 Plus Food Processor", "price": 6499 },
  { "name": "Usha FP 3810 Food Processor", "price": 5999 },
  { "name": "Philips HL1661 Food Processor", "price": 7499 },
  { "name": "Wonderchef Nutri-Blend Food Processor", "price": 3499 },
  { "name": "Prestige PGMFB Grill Sandwich Toaster", "price": 999 },
  { "name": "Bajaj Majesty SWX400 Sandwich Maker", "price": 899 },
  { "name": "Morphy Richards SM3006 Sandwich Maker", "price": 1099 },
  { "name": "Pigeon Egnite Sandwich Maker", "price": 799 },
  { "name": "Usha Sandwich Maker 700W", "price": 999 },
  { "name": "Philips HD2583 Pop-up Toaster", "price": 1499 },
  { "name": "Prestige PPTPKY Pop-up Toaster", "price": 1299 },
  { "name": "Bajaj ATX 4 Pop-up Toaster", "price": 1199 },
  { "name": "Morphy Richards AT 201 Pop-up Toaster", "price": 1399 },
  { "name": "Kent Pop-up Toaster 850W", "price": 999 },
  { "name": "Philips HD4938 Air Fryer", "price": 6999 },
  { "name": "Prestige PAF 6.0 Air Fryer", "price": 5999 },
  { "name": "Inalsa Air Fryer Fry Light", "price": 4999 },
  { "name": "Usha Nutri Fry Air Fryer", "price": 5499 },
  { "name": "Kent Classic Hot Air Fryer", "price": 6499 },
  { "name": "Philips HD9306 Electric Rice Cooker", "price": 2499 },
  { "name": "Prestige Delight Electric Rice Cooker", "price": 2299 },
  { "name": "Bajaj RCX 5 Rice Cooker", "price": 1999 },
  { "name": "Panasonic SR-WA18 Rice Cooker", "price": 2199 },
  { "name": "Usha RC18GS Rice Cooker", "price": 2099 },
  { "name": "Kent Egg Boiler 7 Egg Capacity", "price": 799 },
  { "name": "Prestige Egg Boiler PEGB-01", "price": 699 },
  { "name": "Inalsa Chic Egg Boiler", "price": 599 },
  { "name": "Borosil Smart Egg Boiler", "price": 899 },
  { "name": "Pigeon Egg Boiler 3 Boiling Modes", "price": 499 },

  
  { "name": "Philips GC181 Heavy Weight Dry Iron", "price": 1399 },
  { "name": "Usha EI 1602 Dry Iron", "price": 899 },
  { "name": "Bajaj Majesty MX3 Steam Iron", "price": 1299 },
  { "name": "Morphy Richards Super Glide Steam Iron", "price": 1899 },
  { "name": "Havells Sparkle Steam Iron", "price": 1499 },
  { "name": "Kent OTG 10L Oven Toaster Griller", "price": 2999 },
  { "name": "Wonderchef OTG 19L with Rotisserie", "price": 4999 },
  { "name": "AGARO Marvel 25L Oven Toaster Griller", "price": 3999 },
  { "name": "Prestige POTG 9L Oven Toaster Griller", "price": 2499 },
  { "name": "Borosil Prima 42L OTG", "price": 6999 },
  { "name": "Philips HD9252 Air Fryer", "price": 7499 },
  { "name": "Inalsa Air Fryer Nutri Fry", "price": 5999 },
  { "name": "Usha Nutri Fry Smart Air Fryer", "price": 6499 },
  { "name": "Prestige PAF 4.0 Air Fryer", "price": 4999 },
  { "name": "Kent Classic Hot Air Fryer", "price": 6999 },
  { "name": "Philips HD1172 Dry Iron", "price": 999 },
  { "name": "Bajaj DX7 Dry Iron", "price": 799 },
  { "name": "Usha Aqua Genie Instant Water Heater", "price": 2999 },
  { "name": "Crompton Solarium DLX Instant Geyser", "price": 2599 },
  { "name": "Havells Instanio Prime Instant Geyser", "price": 3499 },
  { "name": "Orient Electric Aura Neo Instant Geyser", "price": 2799 },
  { "name": "Longway Super Instant Water Heater", "price": 1999 },
  { "name": "Kent Grand Plus RO Water Purifier", "price": 10999 },
  { "name": "Aquaguard Glory RO+UV+MTDS", "price": 9999 },
  { "name": "Livpure Glo RO+UV+Mineralizer", "price": 8499 },
  { "name": "Pureit Classic RO+UV Water Purifier", "price": 7999 },
  { "name": "Blue Star Aristo RO+UV Water Purifier", "price": 8999 },
  { "name": "Philips HD4938 Induction Cooktop", "price": 2999 },
  { "name": "Prestige PIC 3.0 V3 Induction Cooktop", "price": 2499 },
  { "name": "Bajaj ICX Pearl Induction Cooker", "price": 2299 },
  { "name": "Usha Cook Joy 3616 Induction Cooktop", "price": 1999 },
  { "name": "Havells Insta Cook ST-X Induction", "price": 2199 },
  { "name": "Kent Egg Boiler 360W", "price": 799 },
  { "name": "Prestige Egg Boiler PEGB-02", "price": 699 },
  { "name": "Inalsa Chic Egg Boiler", "price": 599 },
  { "name": "Borosil Smart Egg Boiler", "price": 899 },
  { "name": "Pigeon Egg Boiler with Auto Shut Off", "price": 499 },
  { "name": "Philips HL1632 Juicer Mixer Grinder", "price": 3499 },
  { "name": "Bajaj JEX 16 Juicer", "price": 2999 },
  { "name": "Prestige PCJ 7.0 Juicer", "price": 2799 },
  { "name": "Usha Nutripress Cold Press Juicer", "price": 8999 },
  { "name": "Wonderchef Cold Press Juicer", "price": 8499 },
  { "name": "Philips HD2584 Pop-up Toaster", "price": 1799 },
  { "name": "Prestige PPTPKY Pop-up Toaster", "price": 1499 },
  { "name": "Bajaj ATX 3 Pop-up Toaster", "price": 1299 },
  { "name": "Morphy Richards AT 201 Toaster", "price": 1399 },
  { "name": "Kent Pop-up Toaster 850W", "price": 999 },
  { "name": "Philips HD7431 Coffee Maker", "price": 2999 },
  { "name": "Morphy Richards Fresco Espresso Maker", "price": 4999 },
  { "name": "Wonderchef Regalia Brew Coffee Maker", "price": 3999 },


  { "name": "Metal Junction Box 4x4", "price": 40 },
  { "name": "PVC Modular Box 6 Module", "price": 20 },
  { "name": "MCB Distribution Box 4-Way", "price": 400 },
  { "name": "Waterproof Steel Junction Box", "price": 250 },
  { "name": "Earthing Bus Bar Box", "price": 300 },
  { "name": "Electrical Pole Box", "price": 350 },
  { "name": "CCTV Junction Box", "price": 200 },
  { "name": "Telephone Junction Box", "price": 200 },
  { "name": "Smoke Detector Junction Box", "price": 40 },
  { "name": "Floor Junction Box 6x6", "price": 40 },
  { "name": "PVC AC Box", "price": 300 },
  { "name": "GI Modular Junction Box", "price": 18 },
  { "name": "Metal Box 1 Module", "price": 54 },
  { "name": "Metal Box 2 Module", "price": 135 },
  { "name": "Metal Box 3 Module", "price": 63 },
  { "name": "Metal Box 4 Module", "price": 72 },
  { "name": "Metal Box 6 Module", "price": 111 },
  { "name": "Metal Box 8 Module", "price": 144 },
  { "name": "Metal Box 12 Module", "price": 185 },
  { "name": "New Work Electrical Box", "price": 55 },
  { "name": "Old Work Electrical Box", "price": 60 },
  { "name": "Standard Rectangular Box", "price": 45 },
  { "name": "2-Gang Electrical Box", "price": 65 },
  { "name": "3-Gang Electrical Box", "price": 85 },
  { "name": "4-Gang Electrical Box", "price": 105 },
  { "name": "Round Pan Electrical Box", "price": 50 },
  { "name": "Octagon Electrical Box", "price": 60 },
  { "name": "Ceiling Fan-Rated Box", "price": 120 },
  { "name": "Square Electrical Box", "price": 70 },
  { "name": "Electrical Box Cover 4x4", "price": 25 },
  { "name": "Outdoor Weatherproof Box", "price": 150 },
  { "name": "Box Extender Ring", "price": 30 },
  { "name": "PVC Surface Box 3 Module", "price": 22 },
  { "name": "PVC Concealed Box 4 Module", "price": 24 },
  { "name": "ABS MCB Box 6-Way", "price": 60 },
  { "name": "Powder Coated GI Box", "price": 55 },
  { "name": "Mini Panel Box", "price": 180 },
  { "name": "Control Terminal Box", "price": 250 },
  { "name": "Splash Proof Junction Box", "price": 275 },
  { "name": "Aluminum Cast Junction Box", "price": 320 },
  { "name": "IP55 Rated Junction Box", "price": 299 },
  { "name": "Plastic Snap-Together Box", "price": 35 },
  { "name": "Weatherproof Enclosure Box", "price": 399 },
  { "name": "Distribution Board Box 8-Way", "price": 450 },
  { "name": "Cable Entry Box with Grommets", "price": 120 },
  { "name": "Raised Cover Box Plate", "price": 40 },
  { "name": "Surface Mount Box 2 Module", "price": 20 },
  { "name": "Concealed Box 6 Module", "price": 28 },
  { "name": "Industrial Lighting Junction Box", "price": 350 },

                  ],
                    "Washing Machines": [
                    
  { "name": "Samsung 7 kg Fully Automatic Top Load Washing Machine", "price": 15490 },
  { "name": "LG 8 kg Smart Inverter Fully Automatic Top Load", "price": 18990 },
  { "name": "Whirlpool 7.5 kg 5 Star Top Load Washing Machine", "price": 17440 },
  { "name": "IFB 6 kg Front Load Washing Machine Diva Aqua SX", "price": 21990 },
  { "name": "Bosch 7 kg Fully Automatic Front Load WAJ2416SIN", "price": 25990 },
  { "name": "Haier 6.5 kg Fully Automatic Top Load Washing Machine", "price": 13990 },
  { "name": "Godrej 7 kg Fully Automatic Top Load WTEON 700", "price": 13490 },
  { "name": "Panasonic 6 kg Fully Automatic Top Load NA-F60LF1HRB", "price": 13990 },
  { "name": "Voltas Beko 7 kg Semi Automatic Washing Machine", "price": 12190 },
  { "name": "Realme TechLife 7 kg Fully Automatic Top Load", "price": 9990 },
  { "name": "Onida 6.5 kg Semi Automatic Top Load Washer", "price": 7990 },
  { "name": "MarQ by Flipkart 7.5 kg Semi Automatic Washer", "price": 7490 },
  { "name": "Croma 6.5 kg Fully Automatic Top Load Washer", "price": 10990 },
  { "name": "BPL 6.2 kg Semi Automatic Washing Machine", "price": 6990 },
  { "name": "Intex 6.5 kg Semi Automatic Top Load", "price": 6490 },
  { "name": "Mitashi 7 kg Semi Automatic Top Load", "price": 7290 },
  { "name": "Hyundai 6.5 kg Semi Automatic Washer", "price": 6890 },
  { "name": "Videocon 7 kg Semi Automatic Washing Machine", "price": 7190 },
  { "name": "Hisense 7 kg Fully Automatic Top Load", "price": 11990 },
  { "name": "Thomson 6.5 kg Semi Automatic Washer", "price": 6990 },
  { "name": "iBell 6.5 kg Semi Automatic Washing Machine", "price": 6790 },
  { "name": "Luminous 6.5 kg Semi Automatic Washer", "price": 6890 },
  { "name": "Syska 6.5 kg Semi Automatic Washing Machine", "price": 6990 },
  { "name": "Reconnect 6.5 kg Semi Automatic Washer", "price": 6790 },
  { "name": "T-Series 6.5 kg Semi Automatic Washing Machine", "price": 6890 },
  { "name": "Nokia 7 kg Fully Automatic Top Load", "price": 11990 },
  { "name": "Vu 6.5 kg Semi Automatic Washer", "price": 6990 },
  { "name": "Detel 6.5 kg Semi Automatic Washing Machine", "price": 6890 },
  { "name": "Zebronics 6.5 kg Semi Automatic Washer", "price": 6990 },
  { "name": "Inalsa 6.5 kg Semi Automatic Washing Machine", "price": 6890 },
  { "name": "Orient Electric 6.5 kg Semi Automatic Washer", "price": 6990 },
  { "name": "Havells 6.5 kg Semi Automatic Washing Machine", "price": 7090 },
  { "name": "Atomberg 7 kg Fully Automatic Top Load", "price": 12990 },
  { "name": "Usha 6.5 kg Semi Automatic Washer", "price": 6990 },
  { "name": "Voltas Beko 8 kg Fully Automatic Top Load", "price": 14990 },
  { "name": "Samsung 8 kg Front Load Ecobubble Washer", "price": 29990 },
  { "name": "LG 9 kg Front Load AI DD Washing Machine", "price": 34990 },
  { "name": "IFB 8 kg Front Load Steam Refresh Washer", "price": 32990 },
  { "name": "Bosch 8 kg Front Load WAJ2826SIN", "price": 28990 },
  { "name": "Whirlpool 9 kg Top Load with Heater", "price": 18990 },
  { "name": "Godrej 8 kg Fully Automatic Top Load", "price": 15990 },
  { "name": "Panasonic 7 kg Fully Automatic Top Load", "price": 14990 },
  { "name": "Haier 8 kg Fully Automatic Top Load", "price": 16990 },
  { "name": "Realme TechLife 8 kg Fully Automatic Washer", "price": 11990 },
  { "name": "Croma 7.5 kg Fully Automatic Top Load", "price": 12990 },
  { "name": "MarQ by Flipkart 8 kg Fully Automatic Washer", "price": 13990 },
  { "name": "Onida 7.5 kg Fully Automatic Top Load", "price": 11990 },
  { "name": "BPL 7.5 kg Fully Automatic Top Load", "price": 12990 },

  
  { "name": "Samsung 6 kg Inverter Fully Automatic Front Load", "price": 22990 },
  { "name": "LG 6.5 kg Smart Inverter Fully Automatic Top Load", "price": 16990 },
  { "name": "Whirlpool 6 kg 5 Star Fully Automatic Top Load", "price": 14990 },
  { "name": "IFB 7 kg Front Load Washing Machine Neo Diva BX", "price": 23990 },
  { "name": "Bosch 6 kg Fully Automatic Front Load WAJ2006EIN", "price": 21990 },
  { "name": "Haier 7 kg Fully Automatic Front Load HW70-BP12929", "price": 20990 },
  { "name": "Godrej 6.2 kg Fully Automatic Top Load WTEON 620", "price": 12490 },
  { "name": "Panasonic 7 kg Fully Automatic Top Load NA-F70LF2HRB", "price": 14990 },
  { "name": "Voltas Beko 6.5 kg Fully Automatic Front Load", "price": 18990 },
  { "name": "Realme TechLife 6.5 kg Fully Automatic Top Load", "price": 9490 },
  { "name": "Onida 7 kg Fully Automatic Top Load T70CGN", "price": 10990 },
  { "name": "MarQ by Flipkart 6 kg Fully Automatic Front Load", "price": 13990 },
  { "name": "Croma 7 kg Semi Automatic Top Load", "price": 8490 },
  { "name": "BPL 7 kg Fully Automatic Top Load", "price": 11990 },
  { "name": "Intex 7 kg Semi Automatic Top Load", "price": 6990 },
  { "name": "Mitashi 6.5 kg Fully Automatic Top Load", "price": 9990 },
  { "name": "Hyundai 7 kg Semi Automatic Washer", "price": 7290 },
  { "name": "Videocon 6.5 kg Fully Automatic Top Load", "price": 10990 },
  { "name": "Hisense 6.5 kg Fully Automatic Front Load", "price": 17990 },
  { "name": "Thomson 7 kg Fully Automatic Top Load", "price": 9990 },
  { "name": "iBell 7 kg Semi Automatic Washing Machine", "price": 6990 },
  { "name": "Luminous 7 kg Fully Automatic Top Load", "price": 10990 },
  { "name": "Syska 7 kg Semi Automatic Washing Machine", "price": 7190 },
  { "name": "Reconnect 7 kg Fully Automatic Top Load", "price": 9990 },
  { "name": "T-Series 7 kg Semi Automatic Washing Machine", "price": 7290 },
  { "name": "Nokia 6.5 kg Fully Automatic Top Load", "price": 10990 },
  { "name": "Vu 7 kg Fully Automatic Top Load", "price": 11990 },
  { "name": "Detel 7 kg Semi Automatic Washing Machine", "price": 6990 },
  { "name": "Zebronics 7 kg Fully Automatic Top Load", "price": 10990 },
  { "name": "Inalsa 7 kg Semi Automatic Washing Machine", "price": 7190 },
  { "name": "Orient Electric 7 kg Fully Automatic Top Load", "price": 11990 },
  { "name": "Havells 7 kg Semi Automatic Washing Machine", "price": 7390 },
  { "name": "Atomberg 8 kg Fully Automatic Top Load", "price": 13990 },
  { "name": "Usha 7 kg Semi Automatic Washer", "price": 7190 },
  { "name": "Voltas Beko 9 kg Fully Automatic Front Load", "price": 27990 },
  { "name": "Samsung 9 kg Top Load with BubbleStorm", "price": 19990 },
  { "name": "LG 10 kg Front Load AI DD Washer Dryer", "price": 49990 },
  { "name": "IFB 9.5 kg Top Load Aqua Energy Washer", "price": 25990 },
  { "name": "Bosch 9 kg Front Load WAJ2846SIN", "price": 31990 },
  { "name": "Whirlpool 10.5 kg Top Load with Heater", "price": 22990 },
  { "name": "Godrej 9 kg Fully Automatic Top Load", "price": 18990 },
  { "name": "Panasonic 8 kg Fully Automatic Top Load", "price": 16990 },
  { "name": "Haier 9 kg Fully Automatic Top Load", "price": 18990 },
  { "name": "Realme TechLife 9 kg Fully Automatic Washer", "price": 13990 },
  { "name": "Croma 8 kg Fully Automatic Top Load", "price": 14990 },
  { "name": "MarQ by Flipkart 9 kg Fully Automatic Washer", "price": 15990 },
  { "name": "Onida 8 kg Fully Automatic Top Load", "price": 13990 },
  { "name": "BPL 8 kg Fully Automatic Top Load", "price": 14990 },


  
  { "name": "Samsung 7 kg Ecobubble Front Load Washer", "price": 24990 },
  { "name": "LG 6 kg Front Load Inverter Washing Machine", "price": 22990 },
  { "name": "Whirlpool 7 kg Top Load with 6th Sense Technology", "price": 16990 },
  { "name": "IFB 6.5 kg Top Load Aqua Conserve", "price": 14990 },
  { "name": "Bosch 6.5 kg Front Load AntiTangle Washer", "price": 23990 },
  { "name": "Haier 6 kg Front Load Inverter Washer", "price": 19990 },
  { "name": "Godrej 6.5 kg Top Load Turbo 6 Technology", "price": 13990 },
  { "name": "Panasonic 6.5 kg Top Load Econavi Washer", "price": 14990 },
  { "name": "Voltas Beko 6 kg Front Load Hygiene+ Washer", "price": 17990 },
  { "name": "Realme TechLife 6 kg Top Load Smart Washer", "price": 8990 },
  { "name": "Onida 6 kg Top Load Eco Washer", "price": 9490 },
  { "name": "MarQ by Flipkart 6.5 kg Top Load Smart Washer", "price": 9990 },
  { "name": "Croma 6 kg Front Load Inverter Washer", "price": 11990 },
  { "name": "BPL 6.5 kg Top Load Aqua Saver", "price": 10990 },
  { "name": "Intex 6 kg Semi Automatic Washer", "price": 5990 },
  { "name": "Mitashi 6 kg Top Load Smart Washer", "price": 8990 },
  { "name": "Hyundai 6 kg Semi Automatic Washer", "price": 6490 },
  { "name": "Videocon 6 kg Top Load Washer", "price": 9990 },
  { "name": "Hisense 6 kg Front Load Inverter Washer", "price": 16990 },
  { "name": "Thomson 6 kg Top Load Washer", "price": 9490 },
  { "name": "iBell 6 kg Semi Automatic Washer", "price": 6390 },
  { "name": "Luminous 6 kg Top Load Washer", "price": 9490 },
  { "name": "Syska 6 kg Semi Automatic Washer", "price": 6590 },
  { "name": "Reconnect 6 kg Top Load Washer", "price": 9390 },
  { "name": "T-Series 6 kg Semi Automatic Washer", "price": 6490 },
  { "name": "Nokia 6 kg Top Load Washer", "price": 9990 },
  { "name": "Vu 6 kg Top Load Washer", "price": 10490 },
  { "name": "Detel 6 kg Semi Automatic Washer", "price": 6390 },
  { "name": "Zebronics 6 kg Top Load Washer", "price": 9990 },
  { "name": "Inalsa 6 kg Semi Automatic Washer", "price": 6490 },
  { "name": "Orient Electric 6 kg Top Load Washer", "price": 9990 },
  { "name": "Havells 6 kg Semi Automatic Washer", "price": 6690 },
  { "name": "Atomberg 6.5 kg Top Load Inverter Washer", "price": 11990 },
  { "name": "Usha 6 kg Semi Automatic Washer", "price": 6590 },
  { "name": "Voltas Beko 6 kg Top Load Washer", "price": 10990 },
  { "name": "Samsung 10 kg Top Load with Digital Inverter", "price": 21990 },
  { "name": "LG 11 kg Front Load Washer Dryer Combo", "price": 52990 },
  { "name": "IFB 10 kg Top Load Aqua Energy Washer", "price": 28990 },
  { "name": "Bosch 10 kg Front Load WAJ2846WIN", "price": 33990 },
  { "name": "Whirlpool 11 kg Top Load with Heater", "price": 24990 },
  { "name": "Godrej 10 kg Fully Automatic Top Load", "price": 20990 },
  { "name": "Panasonic 9 kg Top Load Econavi Washer", "price": 18990 },
  { "name": "Haier 10 kg Top Load Inverter Washer", "price": 20990 },
  { "name": "Realme TechLife 10 kg Top Load Washer", "price": 14990 },
  { "name": "Croma 9 kg Top Load Washer", "price": 16990 },
  { "name": "MarQ by Flipkart 10 kg Top Load Washer", "price": 17990 },
  { "name": "Onida 9 kg Top Load Washer", "price": 15990 },
  { "name": "BPL 9 kg Top Load Washer", "price": 16990 },

            

                  ],
                "Refrigerator": [
                    
  { "name": "Samsung 236L Frost Free Double Door Refrigerator", "price": 25990 },
  { "name": "LG 242L Smart Inverter Double Door Refrigerator", "price": 25990 },
  { "name": "Whirlpool 235L Double Door Refrigerator", "price": 22990 },
  { "name": "Godrej 223L Nano Shield Double Door Refrigerator", "price": 21990 },
  { "name": "Haier 237L Frost Free Double Door Refrigerator", "price": 24990 },
  { "name": "Bosch 207L Single Door Refrigerator", "price": 17990 },
  { "name": "Panasonic 260L Double Door Refrigerator", "price": 26990 },
  { "name": "Voltas Beko 240L Frost Free Refrigerator", "price": 23990 },
  { "name": "Croma 270L Frost Free Double Door Refrigerator", "price": 22990 },
  { "name": "MarQ by Flipkart 245L Double Door Refrigerator", "price": 21990 },
  { "name": "Onida 190L Direct Cool Single Door Refrigerator", "price": 13990 },
  { "name": "BPL 185L Single Door Refrigerator", "price": 12990 },
  { "name": "Intex 190L Single Door Refrigerator", "price": 11990 },
  { "name": "Mitashi 200L Single Door Refrigerator", "price": 12490 },
  { "name": "Hyundai 190L Single Door Refrigerator", "price": 11990 },
  { "name": "Videocon 210L Single Door Refrigerator", "price": 13490 },
  { "name": "Hisense 256L Frost Free Double Door Refrigerator", "price": 24990 },
  { "name": "Thomson 190L Single Door Refrigerator", "price": 12990 },
  { "name": "iBell 185L Single Door Refrigerator", "price": 11990 },
  { "name": "Luminous 190L Single Door Refrigerator", "price": 12490 },
  { "name": "Syska 200L Single Door Refrigerator", "price": 12990 },
  { "name": "Reconnect 190L Single Door Refrigerator", "price": 11990 },
  { "name": "T-Series 185L Single Door Refrigerator", "price": 11990 },
  { "name": "Nokia 210L Frost Free Double Door Refrigerator", "price": 23990 },
  { "name": "Vu 190L Single Door Refrigerator", "price": 12990 },
  { "name": "Detel 185L Single Door Refrigerator", "price": 11990 },
  { "name": "Zebronics 190L Single Door Refrigerator", "price": 12990 },
  { "name": "Inalsa 200L Single Door Refrigerator", "price": 13490 },
  { "name": "Orient Electric 190L Single Door Refrigerator", "price": 12990 },
  { "name": "Havells 210L Frost Free Double Door Refrigerator", "price": 24990 },
  { "name": "Atomberg 220L Smart Inverter Refrigerator", "price": 25990 },
  { "name": "Usha 190L Single Door Refrigerator", "price": 12990 },
  { "name": "Blue Star 215L Deep Freezer", "price": 19450 },
  { "name": "Candy 190L Single Door Refrigerator", "price": 14690 },
  { "name": "Cruise 45L Compact Minibar Refrigerator", "price": 9190 },
  { "name": "Kelvinator 190L Single Door Refrigerator", "price": 13990 },
  { "name": "Electrolux 200L Single Door Refrigerator", "price": 14990 },
  { "name": "Sharp 210L Frost Free Refrigerator", "price": 22990 },
  { "name": "Aisen 190L Single Door Refrigerator", "price": 12990 },
  { "name": "AmazonBasics 190L Single Door Refrigerator", "price": 11990 },
  { "name": "Realme TechLife 210L Frost Free Refrigerator", "price": 23990 },
  { "name": "TCL 240L Frost Free Double Door Refrigerator", "price": 24990 },
  { "name": "Midea 230L Frost Free Refrigerator", "price": 23990 },
  { "name": "Hitachi 260L Frost Free Refrigerator", "price": 28990 },
  { "name": "Carrier 220L Frost Free Refrigerator", "price": 25990 },
  { "name": "AquaDart 250L Commercial Refrigerator", "price": 26990 },
  { "name": "Godrej 244L Convertible Freezer Refrigerator", "price": 24990 },
  { "name": "Samsung 330L Convertible AI Refrigerator", "price": 39490 },
  { "name": "LG 655L Side-by-Side Smart Inverter Refrigerator", "price": 72990 },

  
  
  { "name": "Samsung 275L Convertible Frost Free Refrigerator", "price": 27990 },
  { "name": "LG 308L Smart Inverter Double Door Refrigerator", "price": 31990 },
  { "name": "Whirlpool 265L IntelliFresh Double Door Refrigerator", "price": 28990 },
  { "name": "Godrej 260L Double Door Refrigerator with Nano Shield", "price": 26990 },
  { "name": "Haier 320L Frost Free Double Door Refrigerator", "price": 30990 },
  { "name": "Bosch 347L Frost Free Double Door Refrigerator", "price": 34990 },
  { "name": "Panasonic 336L Double Door Refrigerator", "price": 33990 },
  { "name": "Voltas Beko 340L Frost Free Refrigerator", "price": 31990 },
  { "name": "Croma 310L Frost Free Double Door Refrigerator", "price": 29990 },
  { "name": "MarQ by Flipkart 300L Double Door Refrigerator", "price": 27990 },
  { "name": "Onida 220L Frost Free Double Door Refrigerator", "price": 21990 },
  { "name": "BPL 250L Frost Free Double Door Refrigerator", "price": 23990 },
  { "name": "Intex 230L Frost Free Double Door Refrigerator", "price": 22990 },
  { "name": "Mitashi 240L Frost Free Double Door Refrigerator", "price": 23990 },
  { "name": "Hyundai 260L Frost Free Double Door Refrigerator", "price": 24990 },
  { "name": "Videocon 280L Frost Free Double Door Refrigerator", "price": 26990 },
  { "name": "Hisense 320L Frost Free Double Door Refrigerator", "price": 32990 },
  { "name": "Thomson 310L Frost Free Double Door Refrigerator", "price": 31990 },
  { "name": "iBell 300L Frost Free Double Door Refrigerator", "price": 30990 },
  { "name": "Luminous 280L Frost Free Double Door Refrigerator", "price": 28990 },
  { "name": "Syska 290L Frost Free Double Door Refrigerator", "price": 29990 },
  { "name": "Reconnect 270L Frost Free Double Door Refrigerator", "price": 27990 },
  { "name": "T-Series 260L Frost Free Double Door Refrigerator", "price": 26990 },
  { "name": "Nokia 310L Frost Free Double Door Refrigerator", "price": 31990 },
  { "name": "Vu 280L Frost Free Double Door Refrigerator", "price": 28990 },
  { "name": "Detel 270L Frost Free Double Door Refrigerator", "price": 27990 },
  { "name": "Zebronics 290L Frost Free Double Door Refrigerator", "price": 29990 },
  { "name": "Inalsa 300L Frost Free Double Door Refrigerator", "price": 30990 },
  { "name": "Orient Electric 310L Frost Free Double Door Refrigerator", "price": 31990 },
  { "name": "Havells 330L Frost Free Double Door Refrigerator", "price": 33990 },
  { "name": "Atomberg 320L Smart Inverter Refrigerator", "price": 32990 },
  { "name": "Usha 310L Frost Free Double Door Refrigerator", "price": 31990 },
  { "name": "Blue Star 320L Deep Freezer", "price": 21990 },
  { "name": "Candy 310L Frost Free Double Door Refrigerator", "price": 31990 },
  { "name": "Cruise 50L Compact Minibar Refrigerator", "price": 9990 },
  { "name": "Kelvinator 310L Frost Free Double Door Refrigerator", "price": 31990 },
  { "name": "Electrolux 320L Frost Free Double Door Refrigerator", "price": 32990 },
  { "name": "Sharp 330L Frost Free Double Door Refrigerator", "price": 33990 },
  { "name": "Aisen 310L Frost Free Double Door Refrigerator", "price": 31990 },
  { "name": "AmazonBasics 320L Frost Free Double Door Refrigerator", "price": 32990 },
  { "name": "Realme TechLife 330L Frost Free Refrigerator", "price": 33990 },
  { "name": "TCL 340L Frost Free Double Door Refrigerator", "price": 34990 },
  { "name": "Midea 350L Frost Free Double Door Refrigerator", "price": 35990 },
  { "name": "Hitachi 360L Frost Free Double Door Refrigerator", "price": 36990 },
  { "name": "Carrier 370L Frost Free Double Door Refrigerator", "price": 37990 },
  { "name": "AquaDart 380L Commercial Refrigerator", "price": 38990 },
  { "name": "Godrej 400L Convertible Freezer Refrigerator", "price": 39990 },
  { "name": "Samsung 415L Convertible AI Refrigerator", "price": 41990 },
  { "name": "LG 420L Smart Inverter Double Door Refrigerator", "price": 42990 },

  
  { "name": "Samsung 465L Convertible Frost Free Refrigerator", "price": 44990 },
  { "name": "LG 475L Smart Inverter Double Door Refrigerator", "price": 45990 },
  { "name": "Whirlpool 500L IntelliFresh French Door Refrigerator", "price": 49990 },
  { "name": "Godrej 470L Nano Shield Double Door Refrigerator", "price": 43990 },
  { "name": "Haier 531L Side-by-Side Refrigerator", "price": 54990 },
  { "name": "Bosch 507L Frost Free Side-by-Side Refrigerator", "price": 57990 },
  { "name": "Panasonic 584L Side-by-Side Refrigerator", "price": 59990 },
  { "name": "Voltas Beko 500L Side-by-Side Refrigerator", "price": 52990 },
  { "name": "Croma 550L Side-by-Side Refrigerator", "price": 51990 },
  { "name": "MarQ by Flipkart 565L Side-by-Side Refrigerator", "price": 50990 },
  { "name": "Onida 450L Frost Free Double Door Refrigerator", "price": 39990 },
  { "name": "BPL 480L Frost Free Double Door Refrigerator", "price": 41990 },
  { "name": "Intex 460L Frost Free Double Door Refrigerator", "price": 40990 },
  { "name": "Mitashi 470L Frost Free Double Door Refrigerator", "price": 41990 },
  { "name": "Hyundai 490L Frost Free Double Door Refrigerator", "price": 42990 },
  { "name": "Videocon 510L Frost Free Double Door Refrigerator", "price": 44990 },
  { "name": "Hisense 520L Side-by-Side Refrigerator", "price": 55990 },
  { "name": "Thomson 500L Side-by-Side Refrigerator", "price": 53990 },
  { "name": "iBell 480L Frost Free Double Door Refrigerator", "price": 41990 },
  { "name": "Luminous 470L Frost Free Double Door Refrigerator", "price": 40990 },
  { "name": "Syska 490L Frost Free Double Door Refrigerator", "price": 42990 },
  { "name": "Reconnect 460L Frost Free Double Door Refrigerator", "price": 39990 },
  { "name": "T-Series 450L Frost Free Double Door Refrigerator", "price": 38990 },
  { "name": "Nokia 500L Side-by-Side Refrigerator", "price": 54990 },
  { "name": "Vu 470L Frost Free Double Door Refrigerator", "price": 41990 },
  { "name": "Detel 460L Frost Free Double Door Refrigerator", "price": 40990 },
  { "name": "Zebronics 480L Frost Free Double Door Refrigerator", "price": 42990 },
  { "name": "Inalsa 490L Frost Free Double Door Refrigerator", "price": 43990 },
  { "name": "Orient Electric 500L Side-by-Side Refrigerator", "price": 55990 },
  { "name": "Havells 510L Side-by-Side Refrigerator", "price": 56990 },
  { "name": "Atomberg 520L Smart Inverter Refrigerator", "price": 57990 },
  { "name": "Usha 500L Frost Free Double Door Refrigerator", "price": 54990 },
  { "name": "Blue Star 550L Deep Freezer", "price": 24990 },
  { "name": "Candy 500L Side-by-Side Refrigerator", "price": 53990 },
  { "name": "Cruise 60L Compact Minibar Refrigerator", "price": 10990 },
  { "name": "Kelvinator 500L Side-by-Side Refrigerator", "price": 54990 },
  { "name": "Electrolux 510L Side-by-Side Refrigerator", "price": 55990 },
  { "name": "Sharp 520L Frost Free Side-by-Side Refrigerator", "price": 56990 },
  { "name": "Aisen 500L Frost Free Double Door Refrigerator", "price": 52990 },
  { "name": "AmazonBasics 510L Side-by-Side Refrigerator", "price": 54990 },
  { "name": "Realme TechLife 530L Frost Free Refrigerator", "price": 57990 },
  { "name": "TCL 540L Side-by-Side Refrigerator", "price": 58990 },
  { "name": "Midea 550L Side-by-Side Refrigerator", "price": 59990 },
  { "name": "Hitachi 560L Frost Free Side-by-Side Refrigerator", "price": 60990 },
  { "name": "Carrier 570L Side-by-Side Refrigerator", "price": 61990 },
  { "name": "AquaDart 580L Commercial Refrigerator", "price": 62990 },
  { "name": "Godrej 600L Convertible Freezer Refrigerator", "price": 63990 },
  { "name": "Samsung 630L Convertible AI Side-by-Side Refrigerator", "price": 65990 },
  { "name": "LG 675L Smart Inverter Side-by-Side Refrigerator", "price": 68990 },

                   
                  ],
   
                  
                   "Mike, Speakers/Home Theater speakers": [
                   
  { "name": "Sony HT-S20R 5.1ch Home Theatre System", "price": 14989 },
  { "name": "boAt Aavante Bar 3600 5.1CH Soundbar", "price": 9999 },
  { "name": "ZEBRONICS Omega 7.1 Home Theatre Speaker", "price": 2899 },
  { "name": "Portronics Apollo One Bluetooth Speaker with Mic", "price": 1103 },
  { "name": "DIGIMORE D-1200 Voice Amplifier with Bluetooth Mic", "price": 1399 },
  { "name": "Niwlix Wireless Mini Karaoke Speaker for Kids", "price": 480 },
  { "name": "Storio Rechargeable Bluetooth Karaoke Machine", "price": 563 },
  { "name": "Amisha Wireless Bluetooth Mic with Speaker", "price": 549 },
  { "name": "Portronics Dash 2 Karaoke Mic with 10W Speaker", "price": 3299 },
  { "name": "Humble Kroko Mini Karaoke Speaker with 2 Mics", "price": 779 },
  { "name": "GRAPHENE Wireless Karaoke Mic with LED Lights", "price": 515 },
  { "name": "ZEBRONICS Sound Feast 80 with Wireless Mic", "price": 1899 },
  { "name": "boAt PartyPal 63 Pro Bluetooth Speaker", "price": 4499 },
  { "name": "Ahuja NBA-15 Portable Speaker with Neckband Mic", "price": 2799 },
  { "name": "BONAOK Wireless Bluetooth Karaoke Microphone", "price": 1899 },
  { "name": "Forevermore Bluetooth Karaoke Speaker with Mics", "price": 414 },
  { "name": "Winsumm Portable Karaoke Speaker with Mics", "price": 499 },
  { "name": "Wembley Bluetooth Karaoke Set with Mic & Speaker", "price": 699 },
  { "name": "Hayden Mini Voice Amplifier with Wired Mic", "price": 999 },
  { "name": "ZEBRONICS Juke Bar 200A Soundbar", "price": 2999 },
  { "name": "Sony HT-S40R 5.1ch Home Theatre System", "price": 23989 },
  { "name": "Philips MMS2625B 2.1 Channel Multimedia Speaker", "price": 2999 },
  { "name": "Tronica Enjoy Version-2 Bluetooth Home Theatre", "price": 919 },
  { "name": "TRONICA Super King 5.1 Bluetooth Home Theatre", "price": 2089 },
  { "name": "ZEBRONICS Zeb-Sunshine 60W Bluetooth Speaker", "price": 2299 },
  { "name": "boAt Aavante Bar 5400D 5.1CH Soundbar", "price": 11999 },
  { "name": "TRONICA MADHELL Bluetooth Speaker System", "price": 1709 },
  { "name": "Intex 2.1 Bluetooth Home Theatre System", "price": 2068 },
  { "name": "TRONICA Firefly 5.1 Bluetooth Home Theatre", "price": 2042 },
  { "name": "TRONICA Folk Audio Comet 2.1 Bluetooth Speaker", "price": 2754 },
  { "name": "ZEBRONICS Zeb-Vita 201 Bluetooth Speaker", "price": 1299 },
  { "name": "Mivi Play Bass Boosted Bluetooth Speaker", "price": 689 },
  { "name": "Portronics SoundDrum 1 Bluetooth Speaker", "price": 999 },
  { "name": "PTron Musicbot Lite Bluetooth Speaker", "price": 449 },
  { "name": "boAt Stone 350 Bluetooth Speaker", "price": 1199 },
  { "name": "ZEBRONICS Zeb-Warrior Desktop Speaker", "price": 599 },
  { "name": "Philips Dynamic Bass Boost Bluetooth Speaker", "price": 2999 },
  { "name": "Mivi Fort S16 Tower Speaker", "price": 1099 },
  { "name": "ZEBRONICS Zeb-Juke Bar 9451 Dolby Soundbar", "price": 10499 },
  { "name": "F FERONS Wireless Portable Speaker", "price": 398 },
  { "name": "Seashot MINI BOOST 3 Bluetooth Speaker", "price": 286 },
  { "name": "SnapUp Groove Max Bluetooth Speaker", "price": 499 },
  { "name": "Soundcore Rev Neo 2 Party Speaker", "price": 9999 },
  { "name": "Nu Republic Soundbar 20 Bluetooth Speaker", "price": 729 },
  { "name": "ZEBRONICS Sonic Pod 20 Bluetooth Speaker", "price": 799 },
  { "name": "GOVO GOSURROUND 200 Bluetooth Speaker", "price": 749 },
  { "name": "MZ M406SP Thunder Bluetooth Speaker", "price": 300 },
  { "name": "I Kall IK22 2.1 Channel Home Theatre", "price": 1799 },
  { "name": "SnapUp Boom X Pro RGB Bluetooth Speaker", "price": 849 },

      
  
  
  { "name": "JBL Cinema SB271 Soundbar with Wireless Subwoofer", "price": 8999 },
  { "name": "Philips TAB7007 2.1 Channel Soundbar", "price": 9999 },
  { "name": "Mivi Fort H350 5.1 Channel Soundbar", "price": 5499 },
  { "name": "Boult Bassbox X500 5.1 Dolby Home Theatre", "price": 10999 },
  { "name": "F&D F3800X 5.1 Bluetooth Multimedia Speaker", "price": 6999 },
  { "name": "Infinity Sonic B200WL Soundbar", "price": 6499 },
  { "name": "Realme Cobble Bluetooth Speaker", "price": 1499 },
  { "name": "JBL Go Essential Portable Bluetooth Speaker", "price": 1399 },
  { "name": "Mi Portable Bluetooth Speaker 16W", "price": 2499 },
  { "name": "Marshall Emberton II Bluetooth Speaker", "price": 17999 },
  { "name": "Bose SoundLink Flex Bluetooth Speaker", "price": 15999 },
  { "name": "Sony SRS-XB13 Extra Bass Bluetooth Speaker", "price": 3999 },
  { "name": "AKG Lyra USB Microphone", "price": 8999 },
  { "name": "Blue Yeti Nano USB Microphone", "price": 7999 },
  { "name": "Maono AU-A04 Condenser Mic Kit", "price": 3499 },
  { "name": "Rode NT-USB Mini Microphone", "price": 9999 },
  { "name": "Audio-Technica ATR2500x USB Mic", "price": 8499 },
  { "name": "Samson Meteor Mic USB Studio Microphone", "price": 6999 },
  { "name": "HyperX SoloCast USB Gaming Microphone", "price": 4999 },
  { "name": "Fifine K690 USB Condenser Microphone", "price": 5999 },
  { "name": "Trust GXT 258 Fyru Streaming Mic", "price": 7499 },
  { "name": "Zebronics Zeb-Juke Bar 9700 Pro Dolby Atmos", "price": 12999 },
  { "name": "boAt Aavante Bar 3100D Soundbar", "price": 8999 },
  { "name": "Philips MMS8085B 2.1 Channel Speaker", "price": 6999 },
  { "name": "Intex IT-301 FMUB 4.1 Multimedia Speaker", "price": 4999 },
  { "name": "F&D T60X Tower Speaker", "price": 10999 },
  { "name": "Obage DT-2605 Home Theatre System", "price": 7999 },
  { "name": "Panasonic SC-HT40GW-K 4.1 Speaker System", "price": 6499 },
  { "name": "JBL PartyBox Encore Essential", "price": 17999 },
  { "name": "Sony SRS-XG300 Wireless Party Speaker", "price": 22999 },
  { "name": "Bose Smart Soundbar 300", "price": 29999 },
  { "name": "Marshall Woburn III Bluetooth Speaker", "price": 39999 },
  { "name": "Denon DHT-S316 Soundbar with Subwoofer", "price": 19999 },
  { "name": "Yamaha YAS-209 Soundbar with Alexa", "price": 24999 },
  { "name": "Creative Stage V2 Soundbar", "price": 8999 },
  { "name": "Anker Soundcore Rave Party Speaker", "price": 14999 },
  { "name": "Portronics Breeze Plus Bluetooth Speaker", "price": 1999 },
  { "name": "Mivi Fort S24 Tower Speaker", "price": 1299 },
  { "name": "Zebronics Zeb-BT6590RUCF 5.1 Speaker", "price": 5999 },
  { "name": "boAt Stone 1200 Bluetooth Speaker", "price": 2999 },
  { "name": "Philips SPA8000B/94 5.1 Speaker System", "price": 9999 },
  { "name": "JBL Quantum Stream USB Microphone", "price": 6999 },
  { "name": "Razer Seiren Mini USB Microphone", "price": 4999 },
  { "name": "Maono AU-PM421 USB Mic Kit", "price": 4499 },
  { "name": "Shure MV5 Digital Condenser Microphone", "price": 8999 },
  { "name": "Elgato Wave:3 USB Microphone", "price": 10999 },
  { "name": "Tascam TM-80 Studio Condenser Mic", "price": 5999 },
  { "name": "Zoom ZUM-2 Podcast Mic Pack", "price": 9999 },
  { "name": "Behringer C-1U USB Condenser Mic", "price": 4999 },

  
  { "name": "JBL Bar 2.1 Deep Bass Soundbar", "price": 17999 },
  { "name": "Sony SRS-XE200 Wireless Bluetooth Speaker", "price": 8999 },
  { "name": "Bose SoundLink Micro Bluetooth Speaker", "price": 11999 },
  { "name": "Marshall Kilburn II Portable Speaker", "price": 24999 },
  { "name": "Denon Home Sound Bar 550", "price": 39999 },
  { "name": "Yamaha SR-B20A Soundbar", "price": 17999 },
  { "name": "Creative Pebble V3 Desktop Speakers", "price": 3499 },
  { "name": "Anker Soundcore Motion+ Bluetooth Speaker", "price": 9999 },
  { "name": "Infinity Fuze 100 Wireless Speaker", "price": 1299 },
  { "name": "Realme Pocket Bluetooth Speaker", "price": 999 },
  { "name": "Mi Soundbar with 8 Speaker Drivers", "price": 4999 },
  { "name": "Maono AU-PM360TR Lavalier Microphone", "price": 1499 },
  { "name": "Rode Wireless GO II Dual Channel Mic", "price": 29999 },
  { "name": "Audio-Technica AT2020 Cardioid Mic", "price": 8999 },
  { "name": "Blue Snowball iCE USB Mic", "price": 5999 },
  { "name": "Samson Q2U USB/XLR Dynamic Mic", "price": 6499 },
  { "name": "HyperX QuadCast S RGB USB Mic", "price": 10999 },
  { "name": "Fifine K678 USB Condenser Mic", "price": 5499 },
  { "name": "Trust GXT 252 Emita Streaming Mic", "price": 6999 },
  { "name": "Shure MV7 Podcast Microphone", "price": 18999 },
  { "name": "Elgato Wave:1 USB Microphone", "price": 8999 },
  { "name": "Tascam DR-10L Lavalier Recorder Mic", "price": 14999 },
  { "name": "Zoom H1n Handy Recorder with Mic", "price": 7999 },
  { "name": "Behringer C-2 Studio Condenser Mics", "price": 5999 },
  { "name": "AKG P120 Studio Condenser Mic", "price": 4999 },
  { "name": "JBL PartyBox 110 Bluetooth Speaker", "price": 22999 },
  { "name": "Sony SRS-XP500 Party Speaker", "price": 24999 },
  { "name": "Bose Portable Smart Speaker", "price": 29999 },
  { "name": "Marshall Stanmore II Bluetooth Speaker", "price": 27999 },
  { "name": "Denon DHT-S217 Soundbar", "price": 17999 },
  { "name": "Yamaha NS-P41 5.1 Speaker Package", "price": 24999 },
  { "name": "Creative T100 Hi-Fi Desktop Speakers", "price": 7999 },
  { "name": "Anker Soundcore Flare 2 Speaker", "price": 6999 },
  { "name": "Infinity Fuze Pint Wireless Speaker", "price": 899 },
  { "name": "Realme Brick Bluetooth Speaker", "price": 2999 },
  { "name": "Mi Portable Bluetooth Speaker 5W", "price": 1499 },
  { "name": "Maono AU-903 USB Condenser Mic", "price": 4999 },
  { "name": "Rode NT1-A Studio Mic Kit", "price": 19999 },
  { "name": "Audio-Technica AT875R Shotgun Mic", "price": 9999 },
  { "name": "Blue Yeti X USB Microphone", "price": 12999 },
  { "name": "Samson Go Mic Portable USB Mic", "price": 3999 },
  { "name": "HyperX DuoCast USB Microphone", "price": 7999 },
  { "name": "Fifine K670 USB Condenser Mic", "price": 4499 },
  { "name": "Trust GXT 256 Exxo Streaming Mic", "price": 7999 },
  { "name": "Shure SM58 Vocal Microphone", "price": 8999 },
  { "name": "Elgato Wave DX Dynamic Mic", "price": 10999 },
  { "name": "Tascam TM-280 Studio Mic", "price": 9999 },
  { "name": "Zoom H2n Handy Recorder Mic", "price": 9999 },
  { "name": "Behringer B-1 Studio Condenser Mic", "price": 6999 },



                  ],
      

                   "Lights, Fans and Coolers": [
                  
  { "name": "Philips Starlit 12 Meter LED String Light", "price": 297 },
  { "name": "Desidiya 35 Feet LED Pixel String Light", "price": 88 },
  { "name": "Party Propz Bubble Ball LED Lights", "price": 269 },
  { "name": "Homesake Vintage Wall Lantern", "price": 779 },
  { "name": "One94Store 3D Galaxy Crystal Ball Lamp", "price": 199 },
  { "name": "Lexton 40 LED Fairy String Light", "price": 85 },
  { "name": "PHILIPS 5 Meter Flexishine Rope Light", "price": 699 },
  { "name": "Gesto Neon LED Strip Light with Adapter", "price": 649 },
  { "name": "Desidiya Curtain Star LED String Light", "price": 348 },
  { "name": "Lamp Master Peacock Wall Light", "price": 1049 },
  { "name": "Flyngo Tulip Flower Table Lamp", "price": 445 },
  { "name": "GLUN Mushroom Flower Night Lamp", "price": 153 },
  { "name": "Mahganya Pine Wood Wall Lamp", "price": 326 },
  { "name": "SATYAM KRAFT LED Tea Light Candles (6 pcs)", "price": 263 },
  { "name": "Quace 12 Meter LED String Light", "price": 249 },
  { "name": "NIYAMAX 35 Feet Copper Wire LED Light", "price": 141 },
  { "name": "Trust Ware Panda Night Lamp", "price": 286 },
  { "name": "UZAN Sky Star Projector Lamp", "price": 255 },
  { "name": "PESCA Galaxy Crystal Ball Night Lamp", "price": 196 },
  { "name": "CANDLE 240 LEDs Strip Rice Light", "price": 191 },
  { "name": "Philips Decorative Wall Lamp (Comet)", "price": 450 },
  { "name": "Halonix Bliss USB Fairy Light", "price": 109 },
  { "name": "Desidiya Aluminium Deer Pendant Light", "price": 529 },
  { "name": "Party Propz Moroccan Ball String Light", "price": 298 },
  { "name": "Gesto Waterproof Copper Wire LED Light", "price": 299 },
  { "name": "Crompton Uranus Decorative Fan with Lights", "price": 8889 },
  { "name": "Usha Fontana One Ceiling Fan with Lights", "price": 9489 },
  { "name": "Havells Leganza ES Decorative Fan", "price": 3040 },
  { "name": "Orient Electric Pacific Air Deco Fan", "price": 1498 },
  { "name": "Atomberg Renesa BLDC Fan with LED", "price": 3189 },
  { "name": "Goldmedal Phantom LED Ceiling Fan", "price": 9949 },
  { "name": "RR Signature Jaipur Mahal Designer Fan", "price": 5499 },
  { "name": "Usha Fontana Orchid Fan with Lights", "price": 9599 },
  { "name": "LONGWAY Kiger Decorative Ceiling Fan", "price": 949 },
  { "name": "ACTIVA JETTA 6 Blade Decorative Fan", "price": 3999 },
  { "name": "Orient Wind Wooden Fan with Underlight", "price": 8103 },
  { "name": "Havells Ambrose ES Decorative Fan", "price": 2299 },
  { "name": "Havells Elio Prime BLDC Fan", "price": 3799 },
  { "name": "RR Signature Brooklyn Designer Fan", "price": 3299 },
  { "name": "Havells Elio Decorative Ceiling Fan", "price": 3629 },
  { "name": "Atomberg Ameza LED Indicator Fan", "price": 2499 },
  { "name": "Orient Electric I Tome Plus Fan", "price": 3349 },
  { "name": "Kenstar Snow Breeze Decorative Fan", "price": 1999 },
  { "name": "USHA Mist Air Flo Pedestal Fan", "price": 2599 },
  { "name": "Sansui Chetak Speed Pedestal Fan", "price": 1599 },
  { "name": "IMPEX Twister Plus Tower Fan", "price": 2560 },
  { "name": "Havells Exhaust Fan 200mm", "price": 909 },
  { "name": "Crompton Sea Sapphira Ceiling Fan", "price": 1299 },
  { "name": "Polycab Wizzy Neo BLDC Fan", "price": 2699 },


  
  { "name": "Philips Hue White & Color Ambiance Smart Bulb", "price": 1999 },
  { "name": "Wipro Garnet Smart LED Strip Light", "price": 1499 },
  { "name": "Syska Smart Wi-Fi LED Bulb 9W", "price": 899 },
  { "name": "Mi Motion-Activated Night Light 2", "price": 599 },
  { "name": "Halonix Prime Inverter LED Emergency Bulb", "price": 499 },
  { "name": "Crompton Star Lord Decorative Wall Light", "price": 849 },
  { "name": "Homesake Moroccan Hanging Lantern", "price": 999 },
  { "name": "Desidiya LED Curtain Light 300 LEDs", "price": 399 },
  { "name": "Quace LED Bottle String Light", "price": 289 },
  { "name": "Party Propz Cotton Ball Fairy Lights", "price": 488 },
  { "name": "Gesto Neon Wall Decor Strip Light", "price": 649 },
  { "name": "Philips Wiz Smart Ceiling Light", "price": 2499 },
  { "name": "One94Store Moon Lamp with Touch Control", "price": 499 },
  { "name": "UZAN Romantic Sky Projector Lamp", "price": 253 },
  { "name": "Trust Ware Crystal Rose RGB Lamp", "price": 264 },
  { "name": "PESCA Celestial Ball Night Lamp", "price": 196 },
  { "name": "Flipkart Perfect Homes Tripod Floor Lamp", "price": 1399 },
  { "name": "Mahganya Wall Decor Light Black", "price": 329 },
  { "name": "Lexton LED Rice Light 10 Meter", "price": 199 },
  { "name": "CANDLE 240 LEDs Strip Light White", "price": 191 },
  { "name": "Orient Electric Aeroquiet Premium Fan", "price": 5999 },
  { "name": "Crompton SilentPro Enso Ceiling Fan", "price": 10999 },
  { "name": "Usha Heleous BLDC Remote Fan", "price": 10201 },
  { "name": "Havells Stealth Air BLDC Fan", "price": 11197 },
  { "name": "Polycab Superia Lite SP02 Fan", "price": 10951 },
  { "name": "KUHL Galaxis G8 IoT BLDC Fan", "price": 14549 },
  { "name": "RR Signature Brooklyn Designer Fan", "price": 3299 },
  { "name": "Goldmedal Phantom LED Ceiling Fan", "price": 9949 },
  { "name": "Hans Lightings ESC521YY Fan", "price": 15830 },
  { "name": "KUHL Platin D8 8 Blade BLDC Fan", "price": 16269 },
  { "name": "Havells Enticer Art Decorative Fan", "price": 10790 },
  { "name": "Crompton Sea Sapphira Ceiling Fan", "price": 1299 },
  { "name": "Usha Fontana Lotus Fan with Lights", "price": 9499 },
  { "name": "Orient Electric Wind Wooden Fan", "price": 8103 },
  { "name": "Kenstar Cyclone Tower Air Cooler", "price": 8499 },
  { "name": "Symphony Diet 12T Personal Cooler", "price": 5999 },
  { "name": "Bajaj Platini PX97 Torque Air Cooler", "price": 5990 },
  { "name": "Crompton Ozone Desert Air Cooler", "price": 9999 },
  { "name": "Voltas JetMax 70 Desert Cooler", "price": 10990 },
  { "name": "Havells Freddo i Desert Air Cooler", "price": 12999 },
  { "name": "Orient Electric Snowbreeze Slim Cooler", "price": 8999 },
  { "name": "Blue Star Windus Tower Cooler", "price": 7999 },
  { "name": "Usha Honeywell CL30XC Cooler", "price": 11999 },
  { "name": "Symphony Touch 55 Room Cooler", "price": 10499 },
  { "name": "Bajaj DMH 90 Neo Desert Cooler", "price": 9990 },
  { "name": "Kenstar Double Cool DX Cooler", "price": 8990 },
  { "name": "Voltas Grand 72 Desert Cooler", "price": 11490 },
  { "name": "Crompton Optimus 65 Desert Cooler", "price": 10990 },
  { "name": "Havells Celia i Desert Cooler", "price": 11990 },


  { "name": "Philips Hue Play Light Bar Double Pack", "price": 7999 },
  { "name": "Wipro Smart LED Batten with Alexa Support", "price": 1299 },
  { "name": "Syska Rainbow Smart LED Strip Light", "price": 1599 },
  { "name": "Mi Smart LED Ceiling Light", "price": 3499 },
  { "name": "Halonix Prism RGB LED Strip Light", "price": 899 },
  { "name": "Crompton Aura Designer Wall Light", "price": 999 },
  { "name": "Homesake Industrial Cage Pendant Light", "price": 1399 },
  { "name": "Desidiya LED Icicle Curtain Light", "price": 499 },
  { "name": "Quace LED Mesh Net Light 192 LEDs", "price": 699 },
  { "name": "Party Propz LED Photo Clip String Light", "price": 349 },
  { "name": "Gesto LED Meteor Shower Rain Lights", "price": 799 },
  { "name": "Philips Hue Bloom Table Lamp", "price": 5999 },
  { "name": "One94Store LED Moon Night Light", "price": 399 },
  { "name": "UZAN LED Crystal Ball Fairy Light", "price": 299 },
  { "name": "Trust Ware LED Lotus Flower Lamp", "price": 349 },
  { "name": "PESCA LED Jellyfish Night Light", "price": 289 },
  { "name": "Flipkart SmartBuy LED Strip Light 5M", "price": 599 },
  { "name": "Mahganya Wooden Tripod Floor Lamp", "price": 1499 },
  { "name": "Lexton LED Curtain Light 20 Stars", "price": 499 },
  { "name": "CANDLE LED Rope Light 10M", "price": 399 },
  { "name": "Orient Electric LED Spot Light", "price": 699 },
  { "name": "Crompton LED Panel Light 12W", "price": 499 },
  { "name": "Usha LED Surface Light 15W", "price": 599 },
  { "name": "Havells LED COB Downlight", "price": 899 },
  { "name": "Polycab LED Flood Light 50W", "price": 1499 },
  { "name": "KUHL LED Pendant Light Modern Ring", "price": 2499 },
  { "name": "RR Signature LED Wall Washer Light", "price": 1299 },
  { "name": "Goldmedal LED Mirror Light", "price": 999 },
  { "name": "Hans Lightings LED Chandelier Spiral", "price": 4999 },
  { "name": "KUHL LED Track Light 12W", "price": 799 },
  { "name": "Havells LED Bollard Garden Light", "price": 1899 },
  { "name": "Crompton LED Spike Light Outdoor", "price": 999 },
  { "name": "Usha LED Strip Light RGB Remote", "price": 899 },
  { "name": "Symphony LED Decorative Lantern", "price": 599 },
  { "name": "Bajaj LED Diya String Light", "price": 299 },
  { "name": "Voltas LED Festive Serial Light", "price": 349 },
  { "name": "Havells LED Mason Jar Light", "price": 499 },
  { "name": "Orient Electric LED Bottle Light", "price": 399 },
  { "name": "Blue Star LED Curtain Light 300 LEDs", "price": 599 },
  { "name": "Usha LED Starburst Hanging Light", "price": 899 },
  { "name": "Symphony LED Umbrella String Light", "price": 699 },
  { "name": "Bajaj LED Peacock Wall Light", "price": 999 },
  { "name": "Voltas LED Snowflake Curtain Light", "price": 799 },
  { "name": "Havells LED Globe Pendant Light", "price": 1299 },
  { "name": "Orient Electric LED Crystal Ceiling Light", "price": 1499 },
  { "name": "Blue Star LED Neon Wall Sign", "price": 999 },
  { "name": "Usha LED Rainbow Strip Light", "price": 899 },
  { "name": "Symphony LED Fairy Light Tree", "price": 1999 },
  { "name": "Bajaj LED Diwali Serial Light 20M", "price": 499 },

  { "name": "Bulb", "price": 49 },
  { "name": "Tube light", "price": 119 },
  { "name": "Fan", "price": 949 },
  { "name": "Cooler", "price": 1449 },
  { "name": "Decorative Light", "price": 449 },
  { "name": "Design lights", "price": 649 },
  { "name": "Philips Motion Sensor LED Bulb B22", "price": 364 },
  { "name": "Panasonic Motion Sensor LED Bulb 9W", "price": 169 },
  { "name": "Wipro Garnet Motion Sensor Surface Panel", "price": 715 },
  { "name": "Halonix Radar Motion Sensor LED Bulb", "price": 179 },
  { "name": "Quick Sense PIR Motion Sensor Switch QS-07", "price": 448 },
  { "name": "Blackt Electrotech BT31C PIR Ceiling Sensor", "price": 559 },
  { "name": "DeWire 360° PIR Motion Sensor Switch", "price": 299 },
  { "name": "Schneider CSS54E_WE Occupancy PIR Sensor", "price": 2199 },
  { "name": "ConnectedHome CH-P-CS1 360° PIR Sensor", "price": 672 },
  { "name": "Quick Sense QS-M5A Microwave Radar Sensor", "price": 697 },
  { "name": "Blackt Electrotech BT33 PIR LED Connector", "price": 688 },
  { "name": "Tapo Tp-Link T100 Smart Motion Sensor", "price": 1298 },
  { "name": "Moonlex Smart Motion Sensor Switch", "price": 799 },
  { "name": "Maxwell Microwave Motion Sensor 8m", "price": 640 },
  { "name": "Auto-ON Motion Sensor Holder", "price": 375 },
  { "name": "Quick Sense QS-05B Mini PIR Sensor", "price": 448 },
  { "name": "Electronic Spices PIR Motion Detector", "price": 129 },
  { "name": "Smartify WD31P2 Day/Night Photocell Sensor", "price": 1499 },
  { "name": "Quick Sense QS-M5B Microwave Sensor", "price": 697 },
  { "name": "Philips Hue Motion Sensor", "price": 3499 },
  { "name": "Mi Smart Motion Sensor", "price": 999 },
  { "name": "Zemote Smart Motion Sensor", "price": 1499 },
  { "name": "Hogar Motion Sensor", "price": 1999 },
  { "name": "Oakter Smart Motion Sensor", "price": 1299 },
  { "name": "Realme Motion Sensor Light", "price": 899 },
  { "name": "Syska Motion Sensor LED Panel", "price": 999 },
  { "name": "Crompton Motion Sensor LED Batten", "price": 899 },
  { "name": "Havells Motion Sensor LED Bulb", "price": 499 },
  { "name": "Orient Motion Sensor LED Light", "price": 699 },
  { "name": "Goldmedal Motion Sensor Switch", "price": 899 },
  { "name": "Hans Lighting Motion Sensor Ceiling Light", "price": 1299 },
  { "name": "RR Signature Motion Sensor Wall Light", "price": 999 },
  { "name": "KUHL Motion Sensor LED Strip", "price": 799 },
  { "name": "Voltas Motion Sensor LED Tube", "price": 699 },
  { "name": "Usha Motion Sensor LED Lamp", "price": 599 },
  { "name": "Symphony Motion Sensor Decorative Light", "price": 799 },
  { "name": "Bajaj Motion Sensor Diya Light", "price": 299 },
  { "name": "Blue Star Motion Sensor Curtain Light", "price": 599 },
  { "name": "SmartNode Motion Sensor Switch", "price": 1499 },
  { "name": "Atomberg Motion Sensor Ceiling Fan", "price": 3999 },
  { "name": "Orient Electric Motion Sensor Fan", "price": 3499 },
  { "name": "Crompton Motion Sensor Pedestal Fan", "price": 2999 },
  { "name": "Usha Motion Sensor Exhaust Fan", "price": 2599 },
  { "name": "Havells Motion Sensor Tower Fan", "price": 3199 },
  { "name": "Polycab Motion Sensor BLDC Fan", "price": 2899 },
  { "name": "Goldmedal Motion Sensor Ceiling Fan", "price": 3599 },
  { "name": "RR Signature Motion Sensor Designer Fan", "price": 3999 },
  { "name": "KUHL Motion Sensor IoT Fan", "price": 4499 },
  { "name": "Hans Lighting Motion Sensor Decorative Fan", "price": 4299 },



                  ],          





    
  });

  const [searchText, setSearchText] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  


  const [shopName, setShopName] = useState('');
  const [gstNumber, setGstNumber] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedItem, setSelectedItem] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [cart, setCart] = useState([]);
  const [gstRate, setGstRate] = useState(0);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [showModal, setShowModal] = useState(false);

  const [shareMethod, setShareMethod] = useState('');
  const [pdfFormat, setPdfFormat] = useState('default');


  const handleSearchChange = (event) => {
    const text = event.target.value;
    setSearchText(text);
  
    const allItems = Object.entries(categories).flatMap(([category, items]) =>
      items.map(item => ({ ...item, category }))
    );
  
    const filtered = allItems.filter(item =>
      item.name.toLowerCase().includes(text.toLowerCase())
    );
  
    setSuggestions(filtered);
  };

  const handleSelectSuggestion = (item) => {
    const newItem = {
      name: item.name,
      price: item.price,
      quantity: 1,
      subtotal: item.price * 1,
    };
    setCart([...cart, newItem]);
    setSearchText('');
    setSuggestions([]);
  };

  const handleNewBill = () => {
    setShopName('');
    setGstNumber('');
    setPhoneNumber('');
    setSelectedCategory('');
    setSelectedItem('');
    setQuantity(1);
    setCart([]);
    setGstRate(0);
    setSearchText('');
    setSuggestions([]);
    setPdfFormat('default');
  };
  

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
    setSelectedItem('');
    setQuantity(1);
  };

  const handleItemChange = (event) => {
    setSelectedItem(event.target.value);
    setQuantity(1);
  };

  const handleQuantityChange = (event) => {
    setQuantity(event.target.value);
  };

  const handleAddItem = () => {
    const categoryItems = categories[selectedCategory];
    const item = categoryItems.find(i => i.name === selectedItem);
    if (item) {
      const newItem = {
        name: item.name,
        price: item.price,
        quantity: quantity,
        subtotal: item.price * quantity
      };
      setCart([...cart, newItem]);
      setSelectedItem('');
      setQuantity(1);
    }
  };

  const handleGstRateChange = (event) => {
    setGstRate(event.target.value);
  };

  const handlePriceChange = (index, event) => {
    const newCart = [...cart];
    newCart[index].price = event.target.value;
    newCart[index].subtotal = newCart[index].price * newCart[index].quantity;
    setCart(newCart);
  };

  const handleQuantityEdit = (index, event) => {
    const newCart = [...cart];
    newCart[index].quantity = event.target.value;
    newCart[index].subtotal = newCart[index].price * newCart[index].quantity;
    setCart(newCart);
  };

  const handleRemoveItem = (index) => {
    const newCart = [...cart];
    newCart.splice(index, 1); // Remove one item at the given index
    setCart(newCart);
  };
  
  const calculateTotal = () => {
    const subtotal = cart.reduce((acc, item) => acc + item.subtotal, 0);
    const gst = subtotal * (gstRate / 100);
    const total = subtotal + gst;
    return { subtotal, gst, total };
  };

  const generatePdfInvoice = () => {
    const total = calculateTotal();
    const currentDate = new Date().toLocaleDateString();
    const doc = new jsPDF();

    switch (pdfFormat) {
        case 'default':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item No', 'Item', 'Price', 'Quantity', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

        case 'table':
            doc.autoTable({
                head: [[' Name', 'GST No', 'Phone Number', 'Date']],
                body: [[shopName, gstNumber, phoneNumber, currentDate]],
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                head: [['Item No', 'Item', 'Price', 'Quantity(Kg/Ltr/each)', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

        case 'blueBlack':
            doc.setTextColor(0, 0, 255);
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.setTextColor(0, 0, 0);
            doc.autoTable({
                startY: 40,
                head: [['Item No', 'Item', 'Price', 'Quantity', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

        case 'professionalGrid':
            doc.setFontSize(18);
            doc.text(shopName, 10, 10);
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 10, 20);
            doc.text(`Date: ${currentDate}`, 10, 30);
            doc.autoTable({
                startY: 40,
                head: [['Item No', 'Item', 'Price', 'Quantity', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
                theme: 'grid',
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
                theme: 'grid',
            });
            break;

        case 'compactSummary':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item', 'Quantity', 'Subtotal']],
                body: cart.map((item) => [item.name, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

            
                case 'classicTable':
                    doc.setFontSize(20);
                    doc.text(shopName, 105, 15, null, null, 'center');
                    doc.setFontSize(12);
                    doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
                    doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
                    doc.setFontSize(16);
                    doc.text('Invoice', 105, 30, null, null, 'center');
                    doc.autoTable({
                        startY: 40,
                        head: [['Item No', 'Item', 'Price', 'Quantity(Kg/Ltr/each)', 'Subtotal']],
                        body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
                    });
                    doc.autoTable({
                        startY: doc.lastAutoTable.finalY + 10,
                        body: [
                            ['Subtotal', total.subtotal.toFixed(2)],
                            ['GST', total.gst.toFixed(2)],
                            ['Total', total.total.toFixed(2)],
                        ],
                    });
                    break;
        
                case 'boxedLayout':
                    doc.setFontSize(20);
                    doc.text(shopName, 10, 10);
                    doc.setFontSize(12);
                    doc.text(`GST No: ${gstNumber}`, 10, 20);
                    doc.text(`Date: ${currentDate}`, 10, 30);
                    doc.autoTable({
                        startY: 40,
                        head: [['Item', 'Price', 'Quantity', 'Subtotal']],
                        body: cart.map((item) => [item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
                        styles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0], lineWidth: 0.5 },
                    });
                    doc.autoTable({
                        startY: doc.lastAutoTable.finalY + 10,
                        body: [
                            ['Subtotal', total.subtotal.toFixed(2)],
                            ['GST', total.gst.toFixed(2)],
                            ['Total', total.total.toFixed(2)],
                        ],
                        styles: { fillColor: [0, 180, 0], textColor: [0, 0, 0] },
                    });
            break;   
            
            

        case 'modernMinimalist':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item', 'Quantity(Kg/ltr/each', 'Subtotal']],
                body: cart.map((item) => [item.name, item.quantity, item.subtotal.toFixed(2)]),
                styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.1 },
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
                styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.1 },
            });
            break;

        case 'elegantLines':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item', 'Quantity', 'Subtotal']],
                body: cart.map((item) => [item.name, item.quantity, item.subtotal.toFixed(2)]),
                styles: { fontStyle: 'italic', fontSize: 12, lineColor: [150, 150, 150], lineWidth: 0.1 },
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
                styles: { fontStyle: 'italic', fontSize: 12, lineColor: [150, 150, 150], lineWidth: 0.1 },
            });
            break;

        case 'detailedSections':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Section', 'Details']],
                body: [
                    ['Shop Details', `${shopName}, GST No: ${gstNumber}, Date: ${currentDate}`],
                    ['Items', cart.map((item) => `Name: ${item.name}, Quantity: ${item.quantity}, Subtotal: ${item.subtotal.toFixed(2)}`).join('; ')],
                    ['Totals', `Subtotal: ${total.subtotal.toFixed(2)}, GST: ${total.gst.toFixed(2)}, Total: ${total.total.toFixed(2)}`],
                ],
                styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.5 },
            });
            break;

        

        default:
            break;
    }

    // Save the PDF to Blob
    const pdfBlob = doc.output('blob');

    // Share to WhatsApp
    const shareToWhatsApp = () => {
        const fileURL = URL.createObjectURL(pdfBlob);
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=Your invoice is ready. Download it here: ${fileURL}`;
        window.open(whatsappUrl, '_blank');
    };

    // Share to Email
    const shareToEmail = () => {
        const fileURL = URL.createObjectURL(pdfBlob);
        const mailtoUrl = `mailto:?subject=Your Invoice&body=Your invoice is ready. Download it here: ${fileURL}`;
        window.open(mailtoUrl, '_blank');
    };

    // Share the PDF as needed
    if (shareMethod === 'whatsapp') {
        shareToWhatsApp();
    } else if (shareMethod === 'mail') {
        shareToEmail();
    }

    // Save the PDF
    //doc.save('invoice.pdf');
    doc.save(`${shopName +'-invoice' || 'invoice'}.pdf`);

};


  const handleShare = (method) => {
    setShareMethod(method); // Set the sharing method
    const shareText = `Shop Name: ${shopName}\nGST No: ${gstNumber}\nPhone Number: ${phoneNumber}`;

    if (method === 'whatsapp') {
      window.open(`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(shareText)}`);
    } else if (method === 'mail') {
      window.open(`mailto:?subject=MarketApp%20Details&body=${encodeURIComponent(shareText)}`);
    }

    setShowModal(false); // Close modal after sharing
  };

  const handleGenerateAndShare = () => {
    generatePdfInvoice();
    setShowModal(true); // Show modal after generating PDF
  };

  const handleFormatChange = (e) => {
    setPdfFormat(e.target.value); // Set the PDF format
};

const formatOptions = [
    { value: 'default', label: 'Default' },
    { value: 'table', label: 'Table Format' },
    { value: 'blueBlack', label: 'Blue and Black' },
    { value: 'professionalGrid', label: 'Professional Grid' },
    { value: 'compactSummary', label: 'Compact Summary' },
    { value: 'classicTable', label: 'Classic Table' },
    { value: 'boxedLayout', label: 'Boxed Layout' },
    { value: 'modernMinimalist', label: 'Modern Minimalist' },
    { value: 'elegantLines', label: 'Elegant Lines' },
    { value: 'detailedSections', label: 'Detailed Sections' },
    
];


return (
    <div className="MarketApp">
       <img src="./Images/jalm.png" alt="Just A Little Market" width="100" height="100" />
      <h1><u>Electrical Applicances Store</u></h1>

<div style={{ marginTop: '20px', textAlign: 'left', paddingLeft: '10px' }}>
  <button
    onClick={handleNewBill}
    style={{
      backgroundColor: '#007bff',
      color: '#fff',
      padding: '12px 20px',
      fontSize: '18px',
      fontWeight: '600',
      border: 'none',
      cursor: 'pointer',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0, 123, 255, 0.3)',
      transition: 'background-color 0.3s ease, transform 0.2s ease'
    }}
    onMouseOver={(e) => {
      e.target.style.backgroundColor = '#0056b3';
      e.target.style.transform = 'scale(1.05)';
    }}
    onMouseOut={(e) => {
      e.target.style.backgroundColor = '#007bff';
      e.target.style.transform = 'scale(1)';
    }}
  >
    🧾 New Bill
  </button>
</div>
<br/>

  
      {/* Shop Info */}
  
    <div className="container">
  {/* Responsive Input Section */}
  <div className="input-section">
    <div className="form-group">
      <label>Store Name:</label>
      <input type="text" value={shopName} onChange={(e) => setShopName(e.target.value)} />
    </div>

    <div className="form-group">
      <label>GST No:</label>
      <input type="text" value={gstNumber} onChange={(e) => setGstNumber(e.target.value)} />
    </div>

    <div className="form-group">
      <label>Phone Number:</label>
      <input type="text" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
    </div>

    <div className="form-group">
      <label>Search Items:</label>
      <input
        type="text"
        value={searchText}
        onChange={handleSearchChange}
        placeholder="Type to search..."
      />
      {suggestions.length > 0 && (
        <ul className="suggestion-list">
          {suggestions.map((item, idx) => (
            <li key={idx} onClick={() => handleSelectSuggestion(item)}>
              {item.name} — ₹{item.price} <span className="category">({item.category})</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  </div>

  {/* Category Selection */}
  <div className="form-group">
    <label>Select Category:</label>
    <select onChange={handleCategoryChange} value={selectedCategory}>
      <option value="" disabled>Select a category</option>
      {Object.keys(categories).map((cat, i) => (
        <option key={i} value={cat}>{cat}</option>
      ))}
    </select>
  </div>

  {selectedCategory && (
    <>
      <div className="form-group">
        <label>Select Item:</label>
        <select onChange={handleItemChange} value={selectedItem}>
          <option value="" disabled>Select an item</option>
          {categories[selectedCategory].map((item, i) => (
            <option key={i} value={item.name}>{item.name}</option>
          ))}
        </select>
      </div>

      {selectedItem && (
        <>
          <div className="form-group">
            <label>Quantity:</label>
            <input type="number" value={quantity} onChange={handleQuantityChange} min="1" />
          </div>
          <div className="form-group">
            <button onClick={handleAddItem}>Add Item</button>
          </div>
        </>
      )}
    </>
  )}

  {/* Cart Table */}
  <div className="cart-section">
    <h2>Cart</h2>
    {cart.length === 0 ? (
      <p>No items added.</p>
    ) : (
      <div className="responsive-table">
        <table>
          <thead>
            <tr>
              <th>Item</th>
              <th>Price</th>
              <th>Qty</th>
              <th>Subtotal</th>
              <th>Remove</th>
            </tr>
          </thead>
          <tbody>
            {cart.map((item, index) => (
              <tr key={index}>
                <td>{item.name}</td>
                <td>
                  <input
                    type="number"
                    value={item.price}
                    onChange={(e) => handlePriceChange(index, e)}
                    min="0"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    value={item.quantity}
                    onChange={(e) => handleQuantityEdit(index, e)}
                    min="1"
                  />
                </td>
                <td>{item.subtotal.toFixed(2)}</td>
                <td><button onClick={() => handleRemoveItem(index)}>Remove</button></td>
              </tr>
            ))}
            <tr>
              <td colSpan="3">Subtotal</td>
              <td>{calculateTotal().subtotal.toFixed(2)}</td>
            </tr>
            <tr>
              <td colSpan="3">
                GST Rate:
                <select onChange={handleGstRateChange} value={gstRate}>
                  <option value="0">0%</option>
                  <option value="5">5%</option>
                  <option value="6">6%</option>
                  <option value="9">9%</option>
                  <option value="18">18%</option>
                </select>
              </td>
              <td>{calculateTotal().gst.toFixed(2)}</td>
            </tr>
            <tr>
              <td colSpan="3">Total</td>
              <td>{calculateTotal().total.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    )}
  </div>

  {/* PDF Section */}
{cart.length > 0 && (
 
  <div className="pdf-section" style={{
    marginTop: '30px',
    padding: '20px',
    backgroundColor: '#f1f3f5',
    borderRadius: '10px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  }}>
    <label style={{
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#333'
    }}>
      🧾 Select Invoice Format:
    </label>

    <select
      onChange={handleFormatChange}
      value={pdfFormat}
      style={{
        padding: '10px',
        fontSize: '16px',
        borderRadius: '6px',
        border: '1px solid #ccc',
        width: '100%',
        boxSizing: 'border-box'
      }}
    >
      {formatOptions.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>

    <button
      onClick={handleGenerateAndShare}
      style={{
        backgroundColor: '#007bff',
        color: '#fff',
        padding: '14px',
        fontSize: '17px',
        fontWeight: '600',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        boxShadow: '0 4px 8px rgba(0,123,255,0.3)',
        transition: 'transform 0.2s ease, background-color 0.3s ease'
      }}
      onMouseOver={(e) => {
        e.target.style.backgroundColor = '#0056b3';
        e.target.style.transform = 'scale(1.05)';
      }}
      onMouseOut={(e) => {
        e.target.style.backgroundColor = '#007bff';
        e.target.style.transform = 'scale(1)';
      }}
    >
      📄 Generate PDF Invoice
    </button>
  </div>
)}


<br /><br />

 

</div>

 </div>   
  ); // ✅ this closes the return statement
  
  
}

export default ElectricalAppliances;
  


  

